var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _g2, _path515, _path516, _g3, _path517, _g4, _path518, _g5, _path519, _path520, _g6, _path521, _g7, _path522, _g8, _path523, _path524, _g9, _path525, _g10, _path526, _path527, _g11, _path528, _g12, _path529, _g13, _path530, _g14, _path531, _g15, _path532, _path533, _path534, _path535, _path536, _g16, _path537, _path538, _path539, _g17, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _g18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodebusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_492_23208)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00976562,
    width: 200,
    height: 200,
    rx: 100,
    fill: "white",
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.490234,
    y: 0.5,
    width: 199,
    height: 199,
    rx: 99.5,
    stroke: "#565ADD",
    strokeDasharray: "3 2",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_23208)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 191C150.258 191 191 150.258 191 100C191 49.7421 150.258 9 100 9C49.7421 9 9 49.7421 9 100C9 150.258 49.7421 191 100 191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 190.5C149.982 190.5 190.5 149.982 190.5 100C190.5 50.0182 149.982 9.5 100 9.5C50.0182 9.5 9.5 50.0182 9.5 100C9.5 149.982 50.0182 190.5 100 190.5Z",
    stroke: "#565ADD",
    strokeDasharray: "5 5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 183,
    height: 183
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.002 191.002C150.26 191.002 191.002 150.26 191.002 100.002C191.002 49.744 150.26 9.00195 100.002 9.00195C49.744 9.00195 9.00195 49.744 9.00195 100.002C9.00195 150.26 49.744 191.002 100.002 191.002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_492_23208)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1201 116.224C55.1201 116.224 55.5361 116.601 56.2621 117.224C55.4941 116.599 55.1201 116.224 55.1201 116.224C56.2384 119.3 58.1981 122.001 60.7761 124.018L63.3251 124.363L61.0391 124.539C62.6753 126.104 64.5765 127.367 66.6541 128.267L68.3921 128.187L67.0271 128.669C69.8101 130.693 76.7091 132.324 76.7091 132.324C76.7091 132.324 74.4711 127.143 71.3191 124.687L69.6191 123.187C67.9351 121.822 66.1168 120.632 64.1921 119.635L64.3061 121.256L63.2131 119.256C60.2961 117.712 58.4251 117.883 55.1201 116.224Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M60.9932 121.134L70.0312 126.815",
    stroke: "#455A64",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.087 56.6489C157.087 56.6489 155.987 57.3659 154.139 58.6379C156.013 57.2729 157.087 56.6489 157.087 56.6489C157.087 56.6489 145.234 57.3379 136.056 64.8039L133.756 70.3709L134.725 65.0889C130.202 67.8595 126.207 71.4113 122.925 75.5789L122.067 79.5619L121.791 76.1819C115.544 81.2769 107.731 95.9279 107.731 95.9279C107.731 95.9279 120.8 93.9549 128.246 88.2839L132.669 85.3199C136.766 82.3214 140.548 78.9142 143.955 75.1509L140.215 74.4399L145.389 73.1559C150.628 67.4829 151.355 63.1439 157.087 56.6489Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M144.597 65.5759L125.634 81.5189",
    stroke: "#455A64",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0989 62.094C73.2344 61.7531 72.4761 61.1885 71.9016 60.4581C71.3272 59.7276 70.9573 58.8575 70.8299 57.937C70.6859 56.907 70.4599 55.616 69.1829 55.472C68.9454 55.4577 68.7078 55.4983 68.4886 55.5907C68.2693 55.683 68.0743 55.8246 67.9186 56.0045C67.7629 56.1843 67.6507 56.3977 67.5907 56.6279C67.5308 56.8581 67.5247 57.099 67.5729 57.332C67.7584 58.0974 68.1196 58.809 68.6278 59.4106C69.136 60.0122 69.7773 60.4872 70.5009 60.798C69.4465 60.3903 68.4162 59.9229 67.4149 59.398C66.8162 58.9663 66.3431 58.3829 66.0444 57.7079C65.7456 57.0329 65.6319 56.2905 65.7149 55.557C65.8059 54.737 65.8869 53.699 64.9329 53.337C64.7533 53.2801 64.563 53.2653 64.3768 53.2936C64.1905 53.3219 64.0133 53.3925 63.8587 53.5002C63.7041 53.6078 63.5763 53.7495 63.4851 53.9144C63.3939 54.0793 63.3419 54.2628 63.3329 54.451C63.1239 56.363 65.0269 57.945 66.3329 58.794C65.6592 58.3907 65.0063 57.9535 64.3769 57.484C63.5634 56.9018 62.9394 56.0928 62.5829 55.158C62.2546 54.2547 62.1853 53.2776 62.3829 52.337C62.5919 51.318 62.8119 50.026 61.6569 49.463C61.4379 49.37 61.2005 49.3287 60.963 49.3422C60.7255 49.3558 60.4943 49.4238 60.2874 49.5411C60.0804 49.6584 59.9033 49.8218 59.7697 50.0186C59.636 50.2154 59.5495 50.4404 59.5169 50.676C59.4355 51.4596 59.5378 52.2513 59.8155 52.9884C60.0932 53.7256 60.5388 54.3879 61.1169 54.923C60.2599 54.1863 59.4456 53.4013 58.6779 52.572C58.258 51.9647 58.0075 51.2566 57.952 50.5204C57.8964 49.7842 58.0379 49.0464 58.3619 48.383C58.7229 47.64 59.1469 46.69 58.3689 46.03C58.2188 45.9154 58.0442 45.8369 57.8589 45.8005C57.6735 45.7642 57.4823 45.7711 57.3 45.8206C57.1177 45.8701 56.9492 45.9609 56.8077 46.086C56.6662 46.2112 56.5554 46.3672 56.4839 46.542C55.6459 48.273 56.9089 50.401 57.8559 51.642C57.1009 50.7435 56.4121 49.7913 55.7949 48.793C55.1949 47.167 56.1219 46.019 55.5839 44.978C55.5033 44.8124 55.3859 44.6673 55.2406 44.5541C55.0953 44.4408 54.9261 44.3623 54.7457 44.3246C54.5654 44.2868 54.3789 44.2908 54.2004 44.3363C54.0219 44.3818 53.8561 44.4676 53.7159 44.587C52.5159 45.746 54.6449 48.207 55.7689 49.015C55.9129 49.268 56.0689 49.515 56.2229 49.762C55.2229 48.727 53.8229 47.791 52.9399 48.573C52.8094 48.7031 52.7104 48.8613 52.6505 49.0356C52.5906 49.2099 52.5714 49.3956 52.5944 49.5784C52.6174 49.7612 52.6819 49.9364 52.783 50.0904C52.8842 50.2444 53.0192 50.3733 53.1779 50.467C54.2089 51.111 55.4859 50.193 57.1459 51.085C57.5852 51.663 58.0519 52.2197 58.5459 52.755C56.7929 51.472 54.2689 50.318 53.1749 51.78C53.0298 52.0035 52.9378 52.2571 52.9058 52.5216C52.8738 52.7861 52.9028 53.0543 52.9904 53.3059C53.078 53.5575 53.222 53.7857 53.4114 53.9731C53.6007 54.1604 53.8304 54.302 54.0829 54.387C55.7329 54.995 57.2609 53.334 59.8669 54.093C60.4189 54.617 60.9889 55.122 61.5669 55.61C59.9939 54.742 57.9849 54.071 56.3419 54.957C56.1258 55.0566 55.9356 55.2047 55.786 55.3896C55.6364 55.5746 55.5315 55.7916 55.4792 56.0237C55.427 56.2558 55.429 56.4968 55.4849 56.728C55.5409 56.9592 55.6493 57.1745 55.8019 57.357C56.6759 58.298 57.8479 57.713 58.7629 57.217C59.4272 56.852 60.1637 56.6377 60.9202 56.5894C61.6766 56.541 62.4345 56.6597 63.1399 56.937C63.3781 57.029 63.6023 57.1539 63.8059 57.308C63.9319 57.408 64.0649 57.501 64.1579 57.574C62.8729 56.933 61.2399 56.52 60.6659 57.554C60.5867 57.7204 60.5465 57.9026 60.5486 58.0869C60.5506 58.2711 60.5948 58.4524 60.6777 58.617C60.7606 58.7815 60.88 58.9249 61.0269 59.0362C61.1737 59.1475 61.344 59.2237 61.5249 59.259C62.7129 59.521 63.6079 58.227 65.4709 58.511C66.0782 58.911 66.7046 59.2777 67.3499 59.611C65.2679 58.99 62.5029 58.749 61.9629 60.493C61.9013 60.7521 61.8997 61.0218 61.9583 61.2815C62.0168 61.5413 62.134 61.7842 62.3008 61.9918C62.4677 62.1993 62.6797 62.366 62.9208 62.479C63.1619 62.5921 63.4256 62.6485 63.6919 62.644C65.4499 62.663 66.3329 60.587 69.0429 60.429C69.7429 60.738 70.4429 61.023 71.1579 61.287C69.3839 60.996 67.2669 61.037 66.0159 62.424C65.846 62.5906 65.7167 62.7941 65.6381 63.0187C65.5595 63.2433 65.5337 63.4829 65.5627 63.7191C65.5917 63.9553 65.6748 64.1816 65.8054 64.3805C65.936 64.5794 66.1107 64.7455 66.3159 64.866C67.4549 65.46 68.3639 64.515 69.0589 63.742C69.679 63.0495 70.472 62.5344 71.3568 62.2493C72.2415 61.9643 73.1862 61.9197 74.0939 62.12L74.2419 62.151L74.2279 62.145H74.2429L74.0989 62.094Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.535 95.187C122.692 95.0925 123.804 94.6919 124.756 94.0263C125.708 93.3607 126.466 92.4539 126.952 91.399C127.498 90.22 128.236 88.757 129.816 89.048C130.105 89.117 130.374 89.2517 130.603 89.4417C130.832 89.6317 131.014 89.8718 131.135 90.1435C131.256 90.4152 131.313 90.711 131.301 91.0082C131.289 91.3054 131.209 91.5958 131.067 91.857C130.223 93.67 128.255 94.538 126.308 94.941C127.717 94.8366 129.119 94.6523 130.508 94.389C131.381 94.0898 132.158 93.5638 132.76 92.8649C133.363 92.166 133.768 91.3194 133.936 90.412C134.124 89.398 134.404 88.128 135.676 88.041C135.912 88.0371 136.145 88.0877 136.359 88.1888C136.572 88.2899 136.759 88.4387 136.906 88.6238C137.052 88.8089 137.154 89.0253 137.204 89.2562C137.253 89.487 137.249 89.7261 137.191 89.955C136.748 92.318 133.898 93.52 132.026 94.062C132.977 93.8235 133.917 93.5372 134.84 93.204C136.024 92.8026 137.064 92.061 137.83 91.072C138.549 90.1107 138.985 88.9678 139.089 87.772C139.208 86.478 139.413 84.853 140.999 84.597C141.294 84.5651 141.593 84.6018 141.873 84.7041C142.152 84.8064 142.404 84.9716 142.609 85.1869C142.814 85.4023 142.967 85.662 143.055 85.9459C143.144 86.2297 143.166 86.5302 143.12 86.824C142.932 88.815 141.369 90.292 139.669 91.324C140.961 90.7532 142.22 90.1095 143.44 89.396C144.163 88.8216 144.72 88.0649 145.054 87.2037C145.388 86.3425 145.487 85.4079 145.34 84.496C145.177 83.477 145.015 82.188 146.184 81.679C146.405 81.5964 146.643 81.5659 146.878 81.59C147.113 81.6141 147.339 81.692 147.539 81.8177C147.739 81.9435 147.908 82.1136 148.032 82.315C148.155 82.5164 148.231 82.7436 148.253 82.979C148.628 85.353 146.345 87.441 144.763 88.579C145.992 87.7783 147.162 86.8896 148.263 85.92C149.575 84.194 148.878 82.483 149.899 81.433C150.055 81.2641 150.248 81.1332 150.463 81.0505C150.678 80.9677 150.909 80.9351 151.138 80.9553C151.368 80.9754 151.589 81.0478 151.787 81.1668C151.984 81.2859 152.151 81.4484 152.276 81.642C153.295 83.465 149.853 85.635 148.214 86.194C147.949 86.445 147.676 86.686 147.4 86.922C148.966 86.046 150.98 85.434 151.758 86.69C151.867 86.8929 151.928 87.1181 151.936 87.3483C151.945 87.5785 151.901 87.8077 151.807 88.0181C151.713 88.2285 151.572 88.4147 151.396 88.5624C151.219 88.7101 151.01 88.8153 150.787 88.87C149.32 89.27 148.125 87.705 145.817 88.17C145.083 88.7033 144.323 89.2 143.537 89.66C146.099 88.76 149.537 88.296 150.315 90.442C150.407 90.7617 150.425 91.0984 150.367 91.4262C150.31 91.754 150.178 92.0643 149.982 92.3333C149.786 92.6024 149.531 92.823 149.237 92.9784C148.942 93.1338 148.616 93.2199 148.284 93.23C146.09 93.358 144.865 90.818 141.473 90.781C140.623 91.208 139.757 91.605 138.883 91.981C141.083 91.513 143.726 91.438 145.37 93.095C145.592 93.2925 145.766 93.5386 145.878 93.8142C145.99 94.0898 146.037 94.3874 146.015 94.6841C145.993 94.9807 145.903 95.2683 145.752 95.5246C145.601 95.7809 145.393 95.999 145.145 96.162C143.758 96.971 142.568 95.845 141.654 94.921C140.992 94.2432 140.188 93.7195 139.301 93.3872C138.414 93.0548 137.464 92.9219 136.52 92.998C136.201 93.0206 135.888 93.088 135.589 93.198C135.404 93.266 135.21 93.335 135.071 93.388C136.841 93.088 138.943 93.188 139.255 94.631C139.289 94.8587 139.271 95.0914 139.202 95.3111C139.133 95.5309 139.014 95.7318 138.855 95.8987C138.697 96.0655 138.502 96.1937 138.285 96.2735C138.069 96.3533 137.838 96.3825 137.609 96.359C136.094 96.242 135.492 94.369 133.161 94.034C132.289 94.2893 131.407 94.5023 130.513 94.673C133.228 94.684 136.623 95.399 136.636 97.681C136.616 98.0133 136.52 98.3367 136.355 98.6263C136.191 98.9159 135.963 99.1641 135.688 99.3519C135.413 99.5398 135.099 99.6622 134.769 99.7098C134.44 99.7575 134.104 99.7292 133.787 99.627C131.677 99.013 131.375 96.209 128.187 95.037C127.243 95.154 126.294 95.237 125.346 95.296C127.573 95.591 130.091 96.408 131.085 98.52C131.228 98.7807 131.309 99.0709 131.322 99.368C131.335 99.6651 131.279 99.9612 131.159 100.233C131.039 100.505 130.858 100.746 130.63 100.937C130.402 101.128 130.133 101.264 129.844 101.334C128.266 101.634 127.522 100.172 126.971 98.995C126.48 97.9419 125.718 97.0382 124.763 96.3764C123.809 95.7147 122.695 95.3187 121.537 95.229C121.416 95.22 121.349 95.213 121.349 95.213L121.535 95.187Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.124 93.8939L132.409 107.087L127.42 123.151L117.628 112.043L124.124 93.8939Z",
    fill: "#C7956D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3561 99.353L79.8711 98.545V96.776L81.3561 97.584V99.353Z",
    fill: "#828282"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7223 99.5829L78.2373 98.7749L79.8763 98.5449L81.3613 99.3529L79.7223 99.5829Z",
    fill: "#B4B4B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7223 99.583L78.2373 98.775V97.006L79.7223 97.814V99.583Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7174 97.815L78.2324 97.007L79.8714 96.777L81.3564 97.585L79.7174 97.815Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0768 101.585L76.5918 100.777V99.006L78.0768 99.813V101.585Z",
    fill: "#828282"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4352 101.816L74.9502 101.008L76.5912 100.777L78.0762 101.585L76.4352 101.816Z",
    fill: "#B4B4B4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0797 99.813L76.5947 99.005V97.236L78.0797 98.044V99.813Z",
    fill: "#828282"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7975 102.046L73.3125 101.239L74.9515 101.008L76.4365 101.816L74.7975 102.046Z",
    fill: "#B4B4B4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7282 94.274L78.2432 93.466V91.698L79.7282 92.505V94.274Z",
    fill: "#828282"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.442 98.2759L74.957 97.468L76.598 97.2369L78.083 98.045L76.442 98.2759Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3766 90.5069L79.8916 89.6989V87.9299L81.3766 88.7379V90.5069Z",
    fill: "#828282"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0866 96.276L76.6016 95.468V93.697L78.0866 94.504V96.276Z",
    fill: "#828282"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0885 94.5049L76.6035 93.6979L78.2425 93.4669L79.7275 94.2749L78.0885 94.5049Z",
    fill: "#B4B4B4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.735 90.737L78.25 89.929L79.889 89.699L81.374 90.507L79.735 90.737Z",
    fill: "#B4B4B4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.442 98.275L74.957 97.467V95.698L76.442 96.506V98.275Z",
    fill: "#828282"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.445 96.508L74.96 95.7L76.601 95.469L78.086 96.277L76.445 96.508Z",
    fill: "#B4B4B4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1579 102.277L71.6729 101.469L73.3118 101.239L74.7968 102.046L73.1579 102.277Z",
    fill: "#B4B4B4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3717 88.7379L79.8867 87.9299V86.1589L81.3717 86.9669V88.7379Z",
    fill: "#828282"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0924 92.736L76.6074 91.928L78.2464 91.698L79.7314 92.505L78.0924 92.736Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.735 90.741L78.25 89.933V88.1639L79.735 88.9719V90.741Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0924 92.7369L76.6074 91.9289V90.1599L78.0924 90.9679V92.7369Z",
    fill: "#828282"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8024 98.5059L73.3174 97.6979V95.9299L74.8024 96.7369V98.5059Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5163 102.507L70.0312 101.699L71.6723 101.469L73.1573 102.277L71.5163 102.507Z",
    fill: "#B4B4B4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.737 88.969L78.252 88.161V86.39L79.737 87.198V88.969Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7418 87.199L78.2568 86.391L79.8958 86.161L81.3808 86.969L79.7418 87.199Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1647 98.736L71.6797 97.928L73.3187 97.698L74.8037 98.506L73.1647 98.736Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3834 85.198L79.8984 84.39V82.621L81.3834 83.429V85.198Z",
    fill: "#828282"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0963 90.968L76.6113 90.16V88.391L78.0963 89.199V90.968Z",
    fill: "#828282"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5163 102.508L70.0312 101.7V99.929L71.5163 100.737V102.508Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7448 85.429L78.2598 84.621L79.8988 84.391L81.3838 85.199L79.7448 85.429Z",
    fill: "#B4B4B4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1676 96.968L71.6826 96.158L73.3216 95.928L74.8066 96.735L73.1676 96.968Z",
    fill: "#B4B4B4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1647 98.7369L71.6797 97.9289V96.1599L73.1647 96.9679V98.7369Z",
    fill: "#828282"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7477 83.6599L78.2627 82.8519L79.9017 82.6219L81.3867 83.4299L79.7477 83.6599Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4586 89.43L74.9736 88.622L76.6146 88.391L78.0996 89.199L76.4586 89.43Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1676 96.9679L71.6826 96.1599V94.3889L73.1676 95.1969V96.9679Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8815 100.966L68.3965 100.158L70.0355 99.928L71.5205 100.736L69.8815 100.966Z",
    fill: "#B4B4B4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1051 85.659L76.6201 84.851L78.2591 84.621L79.7441 85.429L78.1051 85.659Z",
    fill: "#B4B4B4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8121 93.197L73.3271 92.39V90.621L74.8121 91.428V93.197Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5309 97.199L70.0459 96.391L71.6869 96.16L73.1719 96.968L71.5309 97.199Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7477 83.6599L78.2627 82.8519V81.0809L79.7477 81.8889V83.6599Z",
    fill: "#828282"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1705 95.196L71.6855 94.388V92.619L73.1705 93.427V95.196Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1745 93.429L71.6895 92.621L73.3284 92.391L74.8134 93.198L73.1745 93.429Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1051 85.66L76.6201 84.852V83.083L78.1051 83.891V85.66Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M74.82 89.659L73.335 88.851L74.974 88.621L76.459 89.429L74.82 89.659Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.817 91.429L73.332 90.619V88.85L74.817 89.658V91.429Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5309 97.195L70.0459 96.387V94.616L71.5309 95.424V97.195Z",
    fill: "#828282"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2399 102.968L66.7549 102.16V100.389L68.2399 101.197V102.968Z",
    fill: "#828282"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2428 101.196L66.7578 100.388L68.3968 100.158L69.8818 100.966L68.2428 101.196Z",
    fill: "#B4B4B4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1745 93.428L71.6895 92.6199V90.851L73.1745 91.659V93.428Z",
    fill: "#828282"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.11 83.891L76.625 83.083V81.312L78.11 82.12V83.891Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1129 82.1189L76.6279 81.3109L78.2669 81.0809L79.7519 81.8889L78.1129 82.1189Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6002 103.198L65.1152 102.39L66.7542 102.16L68.2392 102.968L66.6002 103.198Z",
    fill: "#B4B4B4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5329 93.658L70.0479 92.85L71.6889 92.62L73.1739 93.428L71.5329 93.658Z",
    fill: "#B4B4B4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7536 80.119L78.2686 79.311V77.542L79.7536 78.35V80.119Z",
    fill: "#828282"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4645 85.89L74.9795 85.082V83.313L76.4645 84.121V85.89Z",
    fill: "#828282"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4 76.3499L79.915 75.5419V73.7739L81.4 74.5819V76.3499Z",
    fill: "#828282"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8913 95.657L68.4062 94.849L70.0452 94.619L71.5302 95.427L69.8913 95.657Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1129 82.118L76.6279 81.31V79.541L78.1129 80.349V82.118Z",
    fill: "#828282"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1159 80.35L76.6309 79.542L78.2699 79.312L79.7549 80.12L78.1159 80.35Z",
    fill: "#B4B4B4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6002 103.198L65.1152 102.39V100.619L66.6002 101.427V103.198Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8268 86.1199L73.3418 85.3119L74.9808 85.0819L76.4658 85.8899L74.8268 86.1199Z",
    fill: "#B4B4B4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5368 91.889L70.0518 91.081L71.6928 90.85L73.1778 91.658L71.5368 91.889Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5329 93.6589L70.0479 92.8509V91.0819L71.5329 91.8899V93.6589Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7594 76.58L78.2744 75.772L79.9134 75.542L81.3984 76.35L79.7594 76.58Z",
    fill: "#B4B4B4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2448 99.4279L66.7598 98.62V96.851L68.2448 97.659V99.4279Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2496 97.659L66.7646 96.851L68.4036 96.621L69.8886 97.428L68.2496 97.659Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2448 99.4279L66.7598 98.62V96.851L68.2448 97.659V99.4279Z",
    fill: "#828282"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2496 97.659L66.7646 96.851L68.4036 96.621L69.8886 97.428L68.2496 97.659Z",
    fill: "#B4B4B4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4713 82.3499L74.9863 81.5419L76.6273 81.3109L78.1123 82.1189L76.4713 82.3499Z",
    fill: "#B4B4B4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4684 84.1239L74.9834 83.3159V81.5449L76.4684 82.3529V84.1239Z",
    fill: "#828282"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1852 89.8899L71.7002 89.0819V87.3109L73.1852 88.1189V89.8899Z",
    fill: "#828282"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M81.403 74.5809L79.918 73.7729V72.0039L81.403 72.8119V74.5809Z",
    fill: "#828282"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8913 95.658L68.4062 94.85V93.082L69.8913 93.889V95.658Z",
    fill: "#828282"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7572 78.351V80.1199L78.1182 80.3499V78.5809L79.7572 78.351Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1159 80.3499L76.6309 79.5419V77.7729L78.1159 78.5809V80.3499Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1198 78.581L76.6348 77.773L78.2738 77.543L79.7588 78.351L78.1198 78.581Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8268 86.12L73.3418 85.312V83.543L74.8268 84.351V86.12Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5397 90.122L70.0547 89.314L71.6957 89.083L73.1807 89.891L71.5397 90.122Z",
    fill: "#B4B4B4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4743 80.5779L74.9893 79.7699L76.6303 79.5389L78.1152 80.3469L76.4743 80.5779Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9625 101.658L63.4775 100.851L65.1185 100.62L66.6035 101.428L64.9625 101.658Z",
    fill: "#B4B4B4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9596 103.429L63.4746 102.622V100.851L64.9596 101.658V103.429Z",
    fill: "#828282"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1803 88.118L71.6953 87.31V85.541L73.1803 86.349V88.118Z",
    fill: "#828282"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4069 72.812L79.9219 72.004V70.235L81.4069 71.043V72.812Z",
    fill: "#828282"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1227 76.81L76.6377 76.002L78.2767 75.772L79.7617 76.58L78.1227 76.81Z",
    fill: "#B4B4B4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M66.608 99.656L65.123 98.848V97.079L66.608 97.887V99.656Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8297 84.351L73.3447 83.543V81.771L74.8297 82.579V84.351Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3209 103.659L61.8359 102.851L63.4749 102.621L64.9599 103.428L63.3209 103.659Z",
    fill: "#B4B4B4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5397 90.121L70.0547 89.313V87.541L71.5397 88.349V90.121Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2555 94.1189L66.7705 93.3109L68.4095 93.0809L69.8945 93.8879L68.2555 94.1189Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2525 95.8869L66.7695 95.0789V93.3099L68.2545 94.1179L68.2525 95.8869Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4743 80.5809L74.9893 79.7729V78.0039L76.4743 78.8119V80.5809Z",
    fill: "#828282"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9655 99.8889L63.4805 99.0819L65.1215 98.851L66.6065 99.6589L64.9655 99.8889Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1871 86.35L71.7021 85.542V83.7729L73.1871 84.5809V86.35Z",
    fill: "#828282"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4098 71.043L79.9248 70.235V68.463L81.4098 69.271V71.043Z",
    fill: "#828282"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8971 92.1199L68.4121 91.3129V89.5439L69.8971 90.3519V92.1199Z",
    fill: "#828282"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6139 96.114L65.1289 95.3059L66.7679 95.0759L68.2529 95.8839L66.6139 96.114Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8327 82.579L73.3477 81.771V80.002L74.8327 80.81V82.579Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3209 103.659L61.8359 102.851V101.08L63.3209 101.888V103.659Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5436 88.3499L70.0586 87.5419V85.7729L71.5436 86.5809V88.3499Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2594 92.35L66.7744 91.542L68.4134 91.312L69.8984 92.119L68.2594 92.35Z",
    fill: "#B4B4B4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4811 77.0409L74.9961 76.2329L76.6371 76.002L78.1221 76.81L76.4811 77.0409Z",
    fill: "#B4B4B4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9694 98.1199L63.4844 97.3119L65.1254 97.0809L66.6104 97.8889L64.9694 98.1199Z",
    fill: "#B4B4B4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1901 84.5819L71.7051 83.7739V82.0029L73.1901 82.8109V84.5819Z",
    fill: "#828282"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4127 69.271L79.9277 68.463V66.694L81.4127 67.502V69.271Z",
    fill: "#828282"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6139 96.118L65.1289 95.31V93.541L66.6139 94.349V96.118Z",
    fill: "#828282"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8385 80.812L73.3535 80.004V78.235L74.8385 79.043V80.812Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8395 79.0419L73.3545 78.2339L74.9935 78.0039L76.4785 78.8119L74.8395 79.0419Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3278 100.119L61.8428 99.3109L63.4818 99.0809L64.9668 99.8879L63.3278 100.119Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3239 101.888L61.8389 101.08V99.3109L63.3239 100.119V101.888Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9007 90.351V92.119L68.2617 92.35V90.5809L69.9007 90.351Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2614 90.5819L66.7764 89.7739L68.4154 89.5439L69.9004 90.3519L68.2614 90.5819Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2594 92.3509L66.7744 91.5429V89.7739L68.2594 90.5819V92.3509Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M73.194 82.811L71.709 82.003V80.234L73.194 81.042V82.811Z",
    fill: "#828282"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6803 103.889L60.1953 103.082V101.31L61.6803 102.118V103.889Z",
    fill: "#828282"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4137 67.504L79.9287 66.696V64.928L81.4137 65.736V67.504Z",
    fill: "#828282"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9079 86.811L68.4229 86.0029L70.0619 85.7729L71.5469 86.5809L69.9079 86.811Z",
    fill: "#B4B4B4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8424 77.2709L73.3574 76.4629L74.9964 76.2329L76.4814 77.0409L74.8424 77.2709Z",
    fill: "#B4B4B4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3307 98.35L61.8457 97.542L63.4847 97.312L64.9697 98.12L63.3307 98.35Z",
    fill: "#B4B4B4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6062 99.6609L64.9652 99.892L63.3262 100.123V98.3539L64.9652 98.124L66.6062 97.8929V99.6609Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3278 100.119L61.8428 99.311V97.542L63.3278 98.35V100.119Z",
    fill: "#828282"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0407 104.12L58.5557 103.312L60.1967 103.082L61.6817 103.889L60.0407 104.12Z",
    fill: "#B4B4B4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2614 90.5809L66.7764 89.7729V88.002L68.2614 88.81V90.5809Z",
    fill: "#828282"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9752 94.58L63.4902 93.772L65.1312 93.541L66.6162 94.349L64.9752 94.58Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1979 81.041L71.7129 80.233V78.464L73.1979 79.272V81.041Z",
    fill: "#828282"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6852 102.12L60.2002 101.312V99.543L61.6852 100.351V102.12Z",
    fill: "#828282"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6871 100.349L60.2021 99.5409L61.8412 99.3109L63.3262 100.119L61.6871 100.349Z",
    fill: "#B4B4B4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4196 65.7349L79.9346 64.9269V63.1549L81.4196 63.9629V65.7349Z",
    fill: "#828282"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6237 90.8119L65.1387 90.0039L66.7777 89.7739L68.2627 90.5819L66.6237 90.8119Z",
    fill: "#B4B4B4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6207 92.5799L65.1357 91.7719V90.0039L66.6207 90.8119V92.5799Z",
    fill: "#828282"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3307 98.351L61.8457 97.543V95.772L63.3307 96.58V98.351Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0407 104.121L58.5557 103.313V101.542L60.0407 102.349V104.121Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2682 87.0409L66.7832 86.2329L68.4222 86.0029L69.9072 86.8109L68.2682 87.0409Z",
    fill: "#B4B4B4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2653 88.8099L66.7803 88.0019V86.2329L68.2653 87.0409V88.8099Z",
    fill: "#828282"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9752 94.5809L63.4902 93.7729V92.0039L64.9752 92.8119V94.5809Z",
    fill: "#828282"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9782 92.812L63.4932 92.004L65.1342 91.7729L66.6192 92.5809L64.9782 92.812Z",
    fill: "#B4B4B4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2038 77.501L71.7188 76.693L73.3577 76.463L74.8427 77.271L73.2038 77.501Z",
    fill: "#B4B4B4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M61.692 98.58L60.207 97.774L61.846 97.5439L63.331 98.352L61.692 98.58Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6237 90.8119L65.1387 90.0039V88.2329L66.6237 89.0409V90.8119Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5553 81.2729L70.0703 80.4649V78.6959L71.5553 79.5039V81.2729Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5592 79.503L70.0742 78.695L71.7152 78.464L73.2002 79.272L71.5592 79.503Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0436 102.348L58.5586 101.54V99.771L60.0436 100.578V102.348Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7848 64.1929L78.2998 63.3849L79.9388 63.1549L81.4238 63.9629L79.7848 64.1929Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M64.983 91.0429L63.498 90.2349L65.139 90.0039L66.624 90.8119L64.983 91.0429Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M61.695 96.809L60.21 96.001L61.849 95.771L63.334 96.579L61.695 96.809Z",
    fill: "#B4B4B4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M61.692 98.58L60.207 97.772V96.001L61.692 96.809V98.58Z",
    fill: "#828282"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9176 81.502L68.4326 80.694L70.0716 80.464L71.5566 81.272L69.9176 81.502Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M58.402 104.35L56.917 103.542V101.771L58.402 102.579V104.35Z",
    fill: "#828282"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1422 66.195L76.6572 65.387L78.2962 65.157L79.7812 65.965L78.1422 66.195Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1422 66.195L76.6572 65.387L78.2962 65.157L79.7812 65.965L78.1422 66.195Z",
    fill: "#B4B4B4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6266 89.04L65.1416 88.232V86.463L66.6266 87.271V89.04Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5621 77.731L70.0771 76.923L71.7181 76.692L73.2031 77.5L71.5621 77.731Z",
    fill: "#B4B4B4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0475 100.58L58.5625 99.7719V98.0029L60.0475 98.8109V100.58Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9105 85.043L68.2715 85.273V83.502L69.9105 83.272V85.043Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M68.276 83.502L66.791 82.694L68.43 82.464L69.915 83.272L68.276 83.502Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2721 85.2739L66.7871 84.4659V82.6949L68.2721 83.5029V85.2739Z",
    fill: "#828282"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M68.276 83.502L66.791 82.694L68.43 82.464L69.915 83.272L68.276 83.502Z",
    fill: "#B4B4B4"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2721 85.2739L66.7871 84.4659V82.6949L68.2721 83.5029V85.2739Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7633 104.581L55.2783 103.773L56.9173 103.543L58.4023 104.351L56.7633 104.581Z",
    fill: "#B4B4B4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4977 68.195L75.0127 67.387L76.6537 67.156L78.1387 67.964L76.4977 68.195Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4977 68.195L75.0127 67.387L76.6537 67.156L78.1387 67.964L76.4977 68.195Z",
    fill: "#B4B4B4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9176 81.5019L68.4326 80.6939V78.9249L69.9176 79.7329V81.5019Z",
    fill: "#828282"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4059 102.578L56.9209 101.77V100.001L58.4059 100.809V102.578Z",
    fill: "#828282"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1471 64.424L76.6621 63.616L78.3011 63.386L79.7861 64.194L78.1471 64.424Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3405 93.0419L61.8555 92.2349V90.4659L63.3405 91.2739V93.0419Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3434 91.2759L61.8584 90.4679L63.4974 90.2379L64.9824 91.0459L63.3434 91.2759Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0504 98.8109L58.5654 98.0029V96.2319L60.0504 97.0389V98.8109Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5006 66.426L75.0156 65.618L76.6566 65.387L78.1416 66.195L76.5006 66.426Z",
    fill: "#B4B4B4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5006 66.426L75.0156 65.618L76.6566 65.387L78.1416 66.195L76.5006 66.426Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9928 87.502L63.5078 86.694L65.1488 86.463L66.6338 87.271L64.9928 87.502Z",
    fill: "#B4B4B4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M64.986 89.272L63.501 88.464V86.6949L64.986 87.503V89.272Z",
    fill: "#828282"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2106 73.963L71.7256 73.155V71.386L73.2106 72.194V73.963Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2106 73.963L71.7256 73.155V71.386L73.2106 72.194V73.963Z",
    fill: "#828282"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7018 93.272L60.2168 92.464L61.8558 92.234L63.3408 93.042L61.7018 93.272Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6989 95.041L60.2139 94.233V92.464L61.6989 93.272V95.041Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9235 77.962L68.4385 77.154L70.0775 76.924L71.5625 77.7319L69.9235 77.962Z",
    fill: "#B4B4B4"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4088 100.811L56.9238 100.003V98.234L58.4088 99.042V100.811Z",
    fill: "#828282"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6334 85.5029L65.1484 84.6949V82.924L66.6334 83.7319V85.5029Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1246 104.812L53.6396 104.004L55.2787 103.774L56.7637 104.581L55.1246 104.812Z",
    fill: "#B4B4B4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M74.859 68.425L73.374 67.617L75.013 67.387L76.498 68.195L74.859 68.425Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M74.859 68.425L73.374 67.617L75.013 67.387L76.498 68.195L74.859 68.425Z",
    fill: "#B4B4B4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3463 89.501L61.8613 88.693L63.5003 88.463L64.9853 89.271L63.3463 89.501Z",
    fill: "#B4B4B4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5651 75.964L70.0801 75.156V73.387L71.5651 74.195V75.964Z",
    fill: "#828282"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5651 75.964L70.0801 75.156V73.387L71.5651 74.195V75.964Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0534 97.0389L58.5684 96.2309V94.4619L60.0534 95.2699V97.0389Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0573 95.2659L58.5723 94.4579L60.2133 94.2269L61.6983 95.0349L60.0573 95.2659Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0927 92.736L79.7317 92.505V94.274L78.0927 94.504V96.276L76.4517 96.507V98.276L78.0927 98.045V99.813V101.585L76.4517 101.816L74.8127 102.046L73.1737 102.277L71.5327 102.508V100.737L69.8937 100.967L68.2547 101.198V102.969L66.6157 103.199V101.428L64.9747 101.659V103.43L63.3357 103.661V101.89V100.121L64.9747 99.89L66.6157 99.659V97.89L64.9747 98.121L63.3357 98.351V96.58L61.6967 96.81V98.581L63.3357 98.351V100.12L61.6967 100.35V102.119V103.89L60.0557 104.121V102.349V100.58V98.812V97.04V95.272L61.6967 95.041V93.272L63.3357 93.042V91.273L64.9747 91.043L66.6157 90.812V92.581L64.9747 92.812V94.58L66.6157 94.349V96.118L68.2547 95.888V94.119L69.8937 93.888V95.657L71.5327 95.427V97.198L73.1737 96.967V98.736L74.8127 98.505V96.736L73.1737 96.967V95.196V93.427L74.8127 93.196V91.427V89.659L76.4517 89.429L78.0927 89.198V90.967V92.736Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2819 79.964L66.7969 79.156L68.4359 78.926L69.9209 79.734L68.2819 79.964Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2789 81.7319L66.7939 80.9239V79.1549L68.2789 79.9629V81.7319Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5045 64.654L75.0195 63.846L76.6605 63.615L78.1455 64.423L76.5045 64.654Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9889 85.733L63.5039 84.925L65.1449 84.694L66.6299 85.502L64.9889 85.733Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2135 72.195L71.7285 71.387V69.616L73.2135 70.424V72.195Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2135 72.195L71.7285 71.387V69.616L73.2135 70.424V72.195Z",
    fill: "#828282"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7018 93.2719L60.2168 92.4639V90.6949L61.7018 91.5029V93.2719Z",
    fill: "#828282"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9235 77.962L68.4385 77.154V75.386L69.9235 76.194V77.962Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4137 99.042L56.9287 98.234V96.463L58.4137 97.271V99.042Z",
    fill: "#828282"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6384 81.9629L65.1514 81.1559L66.7904 80.9259L68.2754 81.7339L66.6384 81.9629Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8629 66.659L73.3779 65.851L75.0169 65.621L76.5019 66.429L74.8629 66.659Z",
    fill: "#B4B4B4"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8629 66.659L73.3779 65.851L75.0169 65.621L76.5019 66.429L74.8629 66.659Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M71.568 74.191L70.083 73.383V71.614L71.568 72.422V74.191Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M71.568 74.191L70.083 73.383V71.614L71.568 72.422V74.191Z",
    fill: "#828282"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0602 93.503L58.5752 92.695L60.2162 92.464L61.7012 93.272L60.0602 93.503Z",
    fill: "#B4B4B4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9889 85.7339L63.5039 84.9259V83.1539L64.9889 83.9619V85.7339Z",
    fill: "#828282"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9957 83.962L63.5107 83.154L65.1517 82.923L66.6367 83.731L64.9957 83.962Z",
    fill: "#B4B4B4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M53.484 105.041L51.999 104.233L53.64 104.002L55.125 104.81L53.484 105.041Z",
    fill: "#B4B4B4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1387 67.964V69.733V71.504V73.273L76.4977 73.504L74.8587 73.734L73.2197 73.964V72.195V70.424V68.655L74.8587 68.425L76.4977 68.195L78.1387 67.964Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2204 68.6549L71.7354 67.8469L73.3744 67.6169L74.8594 68.4249L73.2204 68.6549Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2164 70.4239L71.7314 69.6159V67.8469L73.2164 68.6549V70.4239Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2204 68.6559L71.7354 67.8479L73.3744 67.6179L74.8594 68.4259L73.2204 68.6559Z",
    fill: "#B4B4B4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2164 70.4239L71.7314 69.6159V67.8469L73.2164 68.6549V70.4239Z",
    fill: "#828282"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7771 67.733V69.502V71.273V73.042V74.811L78.1381 75.041L76.4971 75.272L74.8581 75.502L73.2191 75.732L71.5781 75.963V74.194V72.425V70.654V68.885V67.116L73.2191 66.885L74.8581 66.655L76.4971 66.425L78.1381 66.194L79.7771 65.964V67.733Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M76.501 66.426L78.142 66.195L79.781 65.965V67.734V69.503V71.274V73.043V74.812L78.142 75.042L76.501 75.273L74.862 75.503L73.223 75.733L71.582 75.964V74.195V72.426V70.655V68.886V67.117L73.223 66.886L74.862 66.656L76.501 66.426Z",
    fill: "#DFDFDF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1358 69.733V71.504V73.273L76.4948 73.504L74.8558 73.734L73.2178 73.964V72.195V70.424V68.655L74.8568 68.425L76.4958 68.195L78.1368 67.964L78.1358 69.733Z",
    fill: "#DFDFDF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7047 91.503L60.2197 90.695V88.924L61.7047 89.7319V91.503Z",
    fill: "#828282"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7086 89.7329L60.2236 88.9249L61.8626 88.6949L63.3476 89.5029L61.7086 89.7329Z",
    fill: "#B4B4B4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9274 76.193L68.4424 75.385V73.616L69.9274 74.424V76.193Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4157 97.271L56.9307 96.463V94.694L58.4157 95.502V97.271Z",
    fill: "#828282"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6384 81.964L65.1514 81.156V79.387L66.6364 80.195L66.6384 81.964Z",
    fill: "#828282"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8659 64.8849L73.3809 64.0769L75.0199 63.8469L76.5049 64.6549L74.8659 64.8849Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5729 72.4259L70.0879 71.6179V69.8469L71.5729 70.6549V72.4259Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5729 72.4259L70.0879 71.6179V69.8469L71.5729 70.6549V72.4259Z",
    fill: "#828282"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0602 93.5019L58.5752 92.6939V90.9249L60.0602 91.7329V93.5019Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2858 78.192L66.8008 77.384V75.615L68.2858 76.423V78.192Z",
    fill: "#828282"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9957 83.962L63.5107 83.154V81.385L64.9957 82.193V83.962Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2223 66.886L71.7373 66.078L73.3763 65.848L74.8613 66.656L73.2223 66.886Z",
    fill: "#B4B4B4"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2223 66.886L71.7373 66.078L73.3763 65.848L74.8613 66.656L73.2223 66.886Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9303 74.426L68.4453 73.618V71.849L69.9303 72.657V74.426Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4186 95.499L56.9336 94.691V92.922L58.4186 93.73V95.499Z",
    fill: "#828282"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6422 78.423L65.1572 77.615L66.7962 77.385L68.2812 78.193L66.6422 78.423Z",
    fill: "#B4B4B4"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3532 85.964L61.8682 85.156V83.385L63.3532 84.193V85.964Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3561 84.193L61.8711 83.385L63.5101 83.155L64.9951 83.963L63.3561 84.193Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8444 105.272L50.3594 104.465L51.9984 104.235L53.4834 105.043L51.8444 105.272Z",
    fill: "#B4B4B4"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5758 70.6539L70.0908 69.8459V68.0769L71.5758 68.8849V70.6539Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5758 70.6539L70.0908 69.8459V68.0769L71.5758 68.8849V70.6539Z",
    fill: "#828282"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0631 91.734L58.5781 90.926V89.155L60.0631 89.963V91.734Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9987 82.1939L63.5137 81.3859V79.6179L64.9987 80.4259V82.1939Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0016 80.426L63.5166 79.618L65.1576 79.387L66.6426 80.195L65.0016 80.426Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2262 65.115L71.7412 64.307L73.3802 64.077L74.8652 64.885L73.2262 65.115Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7116 87.964L60.2266 87.156V85.387L61.7116 86.195V87.964Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7145 86.194L60.2295 85.386L61.8685 85.156L63.3535 85.964L61.7145 86.194Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9332 72.656L68.4482 71.848V70.077L69.9332 70.885V72.656Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4215 93.733L56.9365 92.925V91.156L58.4215 91.964V93.733Z",
    fill: "#828282"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6422 78.422L65.1572 77.614V75.845L66.6422 76.653V78.422Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M66.65 76.654L65.165 75.846L66.804 75.616L68.289 76.424L66.65 76.654Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5827 67.118L70.0977 66.31L71.7387 66.079L73.2237 66.887L71.5827 67.118Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5788 68.885L70.0938 68.077V66.308L71.5788 67.116V68.885Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5827 67.118L70.0977 66.31L71.7387 66.079L73.2237 66.887L71.5827 67.118Z",
    fill: "#B4B4B4"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5788 68.885L70.0938 68.077V66.308L71.5788 67.116V68.885Z",
    fill: "#828282"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0709 88.1939L58.5859 87.3859L60.2269 87.1549L61.7119 87.9629L60.0709 88.1939Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2916 74.655L66.8066 73.847V72.078L68.2916 72.886V74.655Z",
    fill: "#828282"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7145 86.194L60.2295 85.386V83.615L61.7145 84.423V86.194Z",
    fill: "#828282"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2057 105.502L48.7207 104.694L50.3597 104.464L51.8447 105.271L50.2057 105.502Z",
    fill: "#B4B4B4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9362 70.8819L68.4512 70.0739V68.3049L69.9362 69.1129V70.8819Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4284 90.193L56.9434 89.385L58.5824 89.155L60.0674 89.963L58.4284 90.193Z",
    fill: "#B4B4B4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M66.65 76.656L65.165 75.848V74.079L66.65 74.887V76.656Z",
    fill: "#828282"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M66.653 74.886L65.168 74.078L66.807 73.848L68.292 74.656L66.653 74.886Z",
    fill: "#B4B4B4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5856 65.345L70.1006 64.537L71.7416 64.306L73.2266 65.114L71.5856 65.345Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0739 86.426L58.5889 85.618L60.2299 85.387L61.7149 86.195L60.0739 86.426Z",
    fill: "#B4B4B4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2946 72.886L66.8096 72.078V70.307L68.2946 71.115V72.886Z",
    fill: "#828282"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7868 92.194L55.3018 91.387L56.9408 91.156L58.4258 91.964L56.7868 92.194Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0055 78.653L63.5205 77.845V76.077L65.0055 76.885V78.653Z",
    fill: "#828282"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0075 76.8839L63.5225 76.0759L65.1635 75.8409L66.6485 76.6489L65.0075 76.8839Z",
    fill: "#B4B4B4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9401 69.1159L68.4551 68.3079V66.5389L69.9401 67.3469V69.1159Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4313 88.424L56.9463 87.616L58.5853 87.386L60.0703 88.194L58.4313 88.424Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M66.653 74.886L65.168 74.078V72.309L66.653 73.117V74.886Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1432 94.193L53.6582 93.385L55.2972 93.155L56.7822 93.963L55.1432 94.193Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1432 94.193L53.6582 93.385L55.2972 93.155L56.7822 93.963L55.1432 94.193Z",
    fill: "#B4B4B4"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3639 80.6549L61.8789 79.8469V78.0759L63.3639 78.8839V80.6549Z",
    fill: "#828282"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3668 78.887L61.8818 78.079L63.5208 77.849L65.0058 78.657L63.3668 78.887Z",
    fill: "#B4B4B4"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0768 84.653L58.5918 83.845L60.2328 83.614L61.7178 84.422L60.0768 84.653Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M48.568 105.732L47.083 104.924L48.724 104.693L50.209 105.501L48.568 105.732Z",
    fill: "#B4B4B4"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3014 71.116L66.8164 70.3079V68.5389L68.3014 69.3469V71.116Z",
    fill: "#828282"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7897 90.423L55.3047 89.615L56.9437 89.385L58.4287 90.193L56.7897 90.423Z",
    fill: "#B4B4B4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0114 75.117L63.5264 74.309L65.1674 74.078L66.6524 74.886L65.0114 75.117Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0084 76.884L63.5234 76.076V74.307L65.0084 75.115V76.884Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4996 96.1929L52.0146 95.3849L53.6557 95.1539L55.1407 95.9619L53.4996 96.1929Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4996 96.1929L52.0146 95.3849L53.6557 95.1539L55.1407 95.9619L53.4996 96.1929Z",
    fill: "#B4B4B4"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7223 82.655L60.2373 81.847V80.078L61.7223 80.886V82.655Z",
    fill: "#828282"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7243 80.886L60.2393 80.078L61.8783 79.848L63.3633 80.656L61.7243 80.886Z",
    fill: "#B4B4B4"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M69.944 67.347L68.459 66.539V64.7679L69.944 65.5759V67.347Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9469 65.576L68.4619 64.768L70.1009 64.538L71.5859 65.346L69.9469 65.576Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4342 86.655L56.9492 85.847L58.5882 85.6169L60.0732 86.4249L58.4342 86.655Z",
    fill: "#B4B4B4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6569 73.117L65.1719 72.309V70.538L66.6569 71.346V73.117Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 92.425L53.6621 91.617L55.3011 91.387L56.7861 92.194L55.1471 92.425Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3668 78.884L61.8818 78.076V76.307L63.3668 77.115V78.884Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3698 77.115L61.8848 76.307L63.5238 76.077L65.0088 76.885L63.3698 77.115Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0807 82.884L58.5957 82.076L60.2367 81.845L61.7217 82.653L60.0807 82.884Z",
    fill: "#B4B4B4"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3014 69.347L66.8164 68.539V66.77L68.3014 67.578V69.347Z",
    fill: "#828282"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7926 88.655L55.3066 87.846L56.9456 87.616L58.4306 88.424L56.7926 88.655Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7897 90.4229L55.3047 89.6149V87.8459L56.7897 88.6539V90.4229Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5036 94.425L52.0186 93.617L53.6595 93.386L55.1445 94.194L53.5036 94.425Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5036 94.425L52.0186 93.617L53.6595 93.386L55.1445 94.194L53.5036 94.425Z",
    fill: "#B4B4B4"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7243 80.8849L60.2393 80.0769V78.3059L61.7243 79.1139V80.8849Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3665 78.8839V80.6549L61.7275 80.8849V79.1139L63.3665 78.8839Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7282 79.1139L60.2432 78.3059L61.8822 78.0759L63.3672 78.8839L61.7282 79.1139Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2124 101.962L48.7324 101.15V99.381L50.2174 100.189L50.2124 101.962Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2124 101.962L48.7324 101.15V99.381L50.2174 100.189L50.2124 101.962Z",
    fill: "#828282"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4381 84.8839L56.9531 84.0759L58.5921 83.8459L60.0771 84.6539L58.4381 84.8839Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9264 105.963L45.4414 105.155L47.0804 104.925L48.5654 105.733L46.9264 105.963Z",
    fill: "#B4B4B4"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M51.862 96.423L50.377 95.615L52.0159 95.384L53.5009 96.192L51.862 96.423Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M51.862 96.423L50.377 95.615L52.0159 95.384L53.5009 96.192L51.862 96.423Z",
    fill: "#B4B4B4"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0836 81.117L58.5986 80.309L60.2396 80.078L61.7246 80.886L60.0836 81.117Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5621 103.961L47.0771 103.153V101.384L48.5621 102.192V103.961Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5621 103.961L47.0771 103.153V101.384L48.5621 102.192V103.961Z",
    fill: "#828282"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3043 67.574L66.8193 66.766V64.995L68.3043 65.803V67.574Z",
    fill: "#828282"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7965 86.8849L55.3115 86.0769L56.9505 85.8469L58.4355 86.6549L56.7965 86.8849Z",
    fill: "#B4B4B4"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0182 71.576L63.5332 70.768L65.1742 70.537L66.6592 71.345L65.0182 71.576Z",
    fill: "#B4B4B4"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5065 92.655L52.0215 91.847L53.6625 91.616L55.1475 92.424L53.5065 92.655Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7272 79.114L60.2422 78.306V76.537L61.7272 77.345V79.114Z",
    fill: "#828282"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2155 100.193L48.7305 99.385V97.614L50.2155 98.422V100.193Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2155 100.193L48.7305 99.385V97.614L50.2155 98.422V100.193Z",
    fill: "#828282"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M58.442 83.115L56.957 82.307L58.596 82.077L60.081 82.885L58.442 83.115Z",
    fill: "#B4B4B4"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9264 105.963L45.4414 105.155V103.384L46.9264 104.191V105.963Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M55.151 90.6539L53.666 89.8459V88.0769L55.151 88.8849V90.6539Z",
    fill: "#828282"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3737 75.347L61.8887 74.539V72.77L63.3737 73.578V75.347Z",
    fill: "#828282"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8649 94.654L50.3799 93.847L52.0189 93.616L53.5039 94.424L51.8649 94.654Z",
    fill: "#B4B4B4"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8649 94.654L50.3799 93.847L52.0189 93.616L53.5039 94.424L51.8649 94.654Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0866 79.3439L58.6016 78.5359L60.2426 78.3049L61.7276 79.1129L60.0866 79.3439Z",
    fill: "#B4B4B4"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5719 102.192L47.0869 101.384V99.615L48.5719 100.423V102.192Z",
    fill: "#828282"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5719 102.192L47.0869 101.384V99.615L48.5719 100.423V102.192Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7965 85.1139L55.3115 84.3059L56.9505 84.0759L58.4355 84.8839L56.7965 85.1139Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5094 90.883L52.0244 90.075L53.6654 89.844L55.1504 90.652L53.5094 90.883Z",
    fill: "#B4B4B4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7311 77.3459L60.2461 76.5379V74.7689L61.7311 75.5769V77.3459Z",
    fill: "#828282"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M61.735 75.575L60.25 74.767L61.889 74.537L63.374 75.345L61.735 75.575Z",
    fill: "#B4B4B4"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2223 98.423L48.7373 97.615V95.8459L50.2223 96.654V98.423Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2184 96.653L48.7334 95.845L50.3724 95.615L51.8574 96.422L50.2184 96.653Z",
    fill: "#B4B4B4"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2223 98.423L48.7373 97.615V95.8459L50.2223 96.654V98.423Z",
    fill: "#828282"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5748 100.428L47.0898 99.62V97.849L48.5748 98.657V100.428Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5748 100.428L47.0898 99.62V97.849L48.5748 98.657V100.428Z",
    fill: "#828282"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2252 94.8849L48.7402 94.0769L50.3792 93.8469L51.8642 94.6539L50.2252 94.8849Z",
    fill: "#B4B4B4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2252 94.8849L48.7402 94.0769L50.3792 93.8469L51.8642 94.6539L50.2252 94.8849Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5778 98.6529L47.0928 97.8449V96.0759L48.5778 96.8839V98.6529Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5778 98.6529L47.0928 97.8449V96.0759L48.5778 96.8839V98.6529Z",
    fill: "#828282"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5846 95.1159L47.0996 94.3079L48.7406 94.0769L50.2256 94.8849L48.5846 95.1159Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5846 95.1159L47.0996 94.3079L48.7406 94.0769L50.2256 94.8849L48.5846 95.1159Z",
    fill: "#B4B4B4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5807 96.883L47.0957 96.075V94.306L48.5807 95.114V96.883Z",
    fill: "#828282"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5807 96.883L47.0957 96.075V94.306L48.5807 95.114V96.883Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7862 92.194L58.4252 91.964V93.733V95.502V97.271V99.042V100.811V102.58V104.351L56.7862 104.581L55.1472 104.812L53.5062 105.043L51.8672 105.273L50.2282 105.504L48.5872 105.735L46.9482 105.966V104.194V102.425V100.656V98.885V97.116V95.347V93.578L48.5872 93.348L50.2282 93.117L51.8672 92.886L53.5062 92.656L55.1472 92.425L56.7862 92.194Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M56.781 95.732V97.501V99.272V101.041V102.81L55.142 103.041L53.501 103.272L51.862 103.502L50.223 103.733L48.582 103.963V102.194V100.425V98.654V96.885V95.116L50.223 94.886L51.862 94.655L53.501 94.425L55.142 94.194L56.781 93.963V95.732Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M53.504 94.4239L55.145 94.1929L56.784 93.9619V95.7309V97.4999V99.2709V101.04V102.809L55.145 103.04L53.504 103.271L51.865 103.501L50.226 103.732L48.585 103.962V102.193V100.424V98.6529V96.8839V95.1149L50.226 94.8849L51.865 94.6539L53.504 94.4239Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1377 97.7309V99.5019V101.271L53.4967 101.502L51.8577 101.732L50.2188 101.963V100.194V98.4229V96.6539L51.8577 96.4229L53.4967 96.1929L55.1377 95.9619V97.7309Z",
    fill: "#DFDFDF"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M58.445 81.346L56.96 80.538L58.599 80.308L60.084 81.116L58.445 81.346Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9293 104.191L45.4443 103.384V101.615L46.9293 102.423V104.191Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6696 66.0359L65.1846 65.2279L66.8236 64.9979L68.3086 65.8059L66.6696 66.0359Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1579 87.1199L53.6729 86.3119L55.3119 86.0819L56.7969 86.8899L55.1579 87.1199Z",
    fill: "#B4B4B4"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1549 88.885L53.6699 88.077V86.308L55.1549 87.116V88.885Z",
    fill: "#828282"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3766 73.5769L61.8916 72.7689V70.9979L63.3766 71.8059V73.5769Z",
    fill: "#828282"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3795 71.8059L61.8945 70.9979L63.5335 70.7679L65.0185 71.5759L63.3795 71.8059Z",
    fill: "#B4B4B4"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8678 92.8849L50.3828 92.0779L52.0218 91.8469L53.5068 92.6549L51.8678 92.8849Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0866 79.344L58.6016 78.536V76.767L60.0866 77.575V79.344Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8024 83.345L55.3174 82.537L56.9564 82.307L58.4414 83.115L56.8024 83.345Z",
    fill: "#B4B4B4"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7965 85.114L55.3115 84.306V82.537L56.7965 83.345V85.114Z",
    fill: "#828282"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0211 69.807L63.5361 68.999V67.23L65.0211 68.038V69.807Z",
    fill: "#828282"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0231 68.038L63.5381 67.231L65.1791 67L66.6641 67.808L65.0231 68.038Z",
    fill: "#B4B4B4"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0231 68.038L63.5381 67.231L65.1791 67L66.6641 67.808L65.0231 68.038Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0211 69.807L63.5361 68.999V67.23L65.0211 68.038V69.807Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5094 90.884L52.0244 90.076V88.308L53.5094 89.116V90.884Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M61.735 75.577L60.25 74.769V73L61.735 73.808V75.577Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9313 102.423L45.4463 101.615V99.8469L46.9313 100.654V102.423Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1579 87.116L53.6729 86.308V84.537L55.1579 85.345V87.116Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3795 71.806L61.8945 70.998V69.229L63.3795 70.037V71.806Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0934 75.8079L58.6084 74.9999L60.2494 74.7689L61.7344 75.5769L60.0934 75.8079Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0895 77.576L58.6045 76.768V74.999L60.0895 75.807V77.576Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8024 83.3459L55.3174 82.5379V80.7689L56.8024 81.5769V83.3459Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8063 81.577L55.3213 80.769L56.9603 80.5389L58.4453 81.3469L56.8063 81.577Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0289 66.268L63.5439 65.46L65.1849 65.229L66.6699 66.037L65.0289 66.268Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5153 87.347L52.0303 86.539L53.6713 86.308L55.1563 87.116L53.5153 87.347Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7418 72.037L60.2568 71.229L61.8958 70.999L63.3808 71.807L61.7418 72.037Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2291 93.116L48.7441 92.308L50.3831 92.078L51.8681 92.885L50.2291 93.116Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4489 79.576L56.9639 78.768V77L58.4489 77.808V79.576Z",
    fill: "#828282"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9362 100.654L45.4512 99.8469V98.0759L46.9362 98.8829V100.654Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1647 83.576L53.6797 82.768L55.3187 82.538L56.8037 83.346L55.1647 83.576Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8766 89.346L50.3916 88.538L52.0306 88.308L53.5156 89.116L51.8766 89.346Z",
    fill: "#B4B4B4"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8717 91.114L50.3867 90.306V88.537L51.8717 89.345V91.114Z",
    fill: "#828282"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0963 74.039L58.6113 73.231L60.2523 73L61.7373 73.808L60.0963 74.039Z",
    fill: "#B4B4B4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8092 79.805L55.3242 78.997L56.9632 78.767L58.4482 79.575L56.8092 79.805Z",
    fill: "#B4B4B4"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5153 87.346L52.0303 86.538V84.766L53.5153 85.574V87.346Z",
    fill: "#828282"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5192 85.575L52.0342 84.767L53.6752 84.536L55.1602 85.344L53.5192 85.575Z",
    fill: "#B4B4B4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5192 85.5699L52.0342 84.7619V82.9929L53.5192 83.8009V85.5699Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5205 85.575L55.1615 85.344V87.115L53.5205 87.346V85.575Z",
    fill: "#DFDFDF"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7448 70.268L60.2598 69.46L61.8988 69.23L63.3838 70.038L61.7448 70.268Z",
    fill: "#B4B4B4"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M50.233 91.3439L48.748 90.5359L50.3871 90.3059L51.8721 91.1139L50.233 91.3439Z",
    fill: "#B4B4B4"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4557 77.806L56.9707 76.998V75.229L58.4557 76.037V77.806Z",
    fill: "#828282"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9391 98.883L45.4541 98.076V96.307L46.9391 97.114V98.883Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1647 83.5749L53.6797 82.7669V80.9979L55.1647 81.8059V83.5749Z",
    fill: "#828282"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3864 68.2699L61.9014 67.4619V65.6899L63.3864 66.4979V68.2699Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3893 66.4939L61.9043 65.6859L63.5433 65.4559L65.0283 66.2639L63.3893 66.4939Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0963 74.0399L58.6113 73.2319V71.4609L60.0963 72.2689V74.0399Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0993 72.267L58.6143 71.459L60.2552 71.228L61.7402 72.036L60.0993 72.267Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5875 93.347L47.1025 92.539L48.7435 92.308L50.2285 93.116L48.5875 93.347Z",
    fill: "black"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7477 68.4989L60.2627 67.6909L61.9017 67.4609L63.3867 68.2689L61.7477 68.4989Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4508 76.037L56.9658 75.229V73.46L58.4508 74.268V76.037Z",
    fill: "#828282"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M46.943 97.1149L45.458 96.3079V94.5389L46.943 95.3459V97.1149Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1705 80.0359L53.6855 79.2279L55.3246 78.9979L56.8096 79.8059L55.1705 80.0359Z",
    fill: "#B4B4B4"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8805 85.805L50.3955 84.997L52.0345 84.767L53.5195 85.575L51.8805 85.805Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1022 70.498L58.6172 69.69L60.2582 69.459L61.7432 70.267L60.1022 70.498Z",
    fill: "#B4B4B4"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5914 91.575L47.1064 90.767L48.7475 90.536L50.2325 91.344L48.5914 91.575Z",
    fill: "#B4B4B4"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M53.527 82.037L52.042 81.225L53.683 80.994L55.168 81.802L53.527 82.037Z",
    fill: "black"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4577 74.2689L56.9727 73.4609V71.6899L58.4577 72.4979V74.2689Z",
    fill: "#828282"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9498 93.577L45.4648 92.77L47.1039 92.5389L48.5889 93.347L46.9498 93.577Z",
    fill: "black"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9459 95.3449L45.4609 94.5379V92.7689L46.9459 93.5759V95.3449Z",
    fill: "black"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8844 84.037L50.3994 83.229L52.0384 82.999L53.5234 83.807L51.8844 84.037Z",
    fill: "#B4B4B4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8805 85.805L50.3955 84.997V83.228L51.8805 84.036V85.805Z",
    fill: "#828282"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M60.11 68.7299L58.625 67.9219L60.266 67.6909L61.751 68.4989L60.11 68.7299Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1022 70.498L58.6172 69.69V67.921L60.1022 68.729V70.498Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5914 91.5749L47.1064 90.7669V88.9979L48.5914 89.8059V91.5749Z",
    fill: "black"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5309 80.267L52.0459 79.459L53.6869 79.228L55.1719 80.036L53.5309 80.267Z",
    fill: "#B4B4B4"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4616 72.499L56.9766 71.691V69.922L58.4616 70.73V72.499Z",
    fill: "#828282"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8873 82.268L50.4023 81.46L52.0413 81.23L53.5263 82.038L51.8873 82.268Z",
    fill: "black"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2428 86.035L48.7578 85.227V83.458L50.2428 84.266V86.035Z",
    fill: "black"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4645 70.73L56.9795 69.922V68.153L58.4645 68.961V70.73Z",
    fill: "#828282"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9557 90.037L45.4707 89.229L47.1097 88.999L48.5947 89.807L46.9557 90.037Z",
    fill: "#B4B4B4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8903 80.496L50.4053 79.688L52.0443 79.458L53.5293 80.266L51.8903 80.496Z",
    fill: "#B4B4B4"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6002 86.267L47.1152 85.459L48.7562 85.228L50.2412 86.036L48.6002 86.267Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2487 82.4989L48.7637 81.6909L50.4027 81.4609L51.8877 82.2689L50.2487 82.4989Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4664 68.961L56.9814 68.153V66.381L58.4664 67.189V68.961Z",
    fill: "#828282"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9557 90.036L45.4707 89.228V87.459L46.9557 88.267V90.036Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6041 84.497L47.1191 83.689L48.7601 83.458L50.2451 84.266L48.6041 84.497Z",
    fill: "#B4B4B4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2526 80.728L48.7676 79.92L50.4066 79.6899L51.8916 80.498L50.2526 80.728Z",
    fill: "#B4B4B4"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9625 86.497L45.4775 85.689L47.1165 85.459L48.6015 86.267L46.9625 86.497Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9596 88.268L45.4746 87.46V85.689L46.9596 86.497V88.268Z",
    fill: "black"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6041 82.7289L47.1191 81.9209L48.7601 81.6899L50.2451 82.498L48.6041 82.7289Z",
    fill: "black"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8327 67.42L55.3477 66.612L56.9866 66.382L58.4716 67.19L56.8327 67.42Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9655 84.728L45.4805 83.92L47.1195 83.6899L48.6045 84.4979L46.9655 84.728Z",
    fill: "#B4B4B4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1901 69.4209L53.7051 68.6129L55.3441 68.3829L56.8291 69.1909L55.1901 69.4209Z",
    fill: "black"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1901 69.4209L53.7051 68.6129L55.3441 68.3829L56.8291 69.1909L55.1901 69.4209Z",
    fill: "#B4B4B4"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M48.611 80.9579L47.126 80.1499L48.767 79.9189L50.252 80.7269L48.611 80.9579Z",
    fill: "#B4B4B4"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5455 71.419L52.0605 70.611L53.7016 70.38L55.1866 71.188L53.5455 71.419Z",
    fill: "black"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5455 71.419L52.0605 70.611L53.7016 70.38L55.1866 71.188L53.5455 71.419Z",
    fill: "#B4B4B4"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9655 84.729L45.4805 83.921V82.152L46.9655 82.96V84.729Z",
    fill: "black"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9684 82.962L45.4834 82.154L47.1224 81.924L48.6074 82.7319L46.9684 82.962Z",
    fill: "black"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M55.194 67.649L53.709 66.841L55.348 66.611L56.833 67.419L55.194 67.649Z",
    fill: "black"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5495 69.6509L52.0645 68.8429L53.7054 68.6119L55.1904 69.4199L53.5495 69.6509Z",
    fill: "black"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5495 69.6509L52.0645 68.8429L53.7054 68.6119L55.1904 69.4199L53.5495 69.6509Z",
    fill: "#B4B4B4"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2584 77.1889L48.7734 76.3809V74.6119L50.2584 75.4199V77.1889Z",
    fill: "black"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2584 77.1889L48.7734 76.3809V74.6119L50.2584 75.4199V77.1889Z",
    fill: "#828282"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9723 81.188L45.4873 80.38L47.1263 80.15L48.6113 80.958L46.9723 81.188Z",
    fill: "#B4B4B4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9079 71.6509L50.4229 70.8429L52.0618 70.6129L53.5468 71.4209L51.9079 71.6509Z",
    fill: "black"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9079 71.6509L50.4229 70.8429L52.0618 70.6129L53.5468 71.4209L51.9079 71.6509Z",
    fill: "#B4B4B4"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6149 79.1899L47.1299 78.3819V76.6129L48.6149 77.4209V79.1899Z",
    fill: "black"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6149 79.1899L47.1299 78.3819V76.6129L48.6149 77.4209V79.1899Z",
    fill: "#828282"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5524 67.8799L52.0674 67.0719L53.7084 66.8409L55.1934 67.6489L53.5524 67.8799Z",
    fill: "black"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2584 75.4209L48.7734 74.6129V72.8419L50.2584 73.6499V75.4209Z",
    fill: "black"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2584 75.4209L48.7734 74.6129V72.8419L50.2584 73.6499V75.4209Z",
    fill: "#828282"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9723 81.1879L45.4873 80.3799V78.6119L46.9723 79.4199V81.1879Z",
    fill: "black"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9098 69.882L50.4248 69.074L52.0638 68.844L53.5488 69.652L51.9098 69.882Z",
    fill: "#B4B4B4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9098 69.882L50.4248 69.074L52.0638 68.844L53.5488 69.652L51.9098 69.882Z",
    fill: "black"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6178 77.423L47.1328 76.615V74.8459L48.6178 75.6539V77.423Z",
    fill: "#828282"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6178 77.423L47.1328 76.615V74.8459L48.6178 75.6539V77.423Z",
    fill: "black"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2653 73.65L48.7803 72.842V71.073L50.2653 71.881V73.65Z",
    fill: "black"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2682 71.881L48.7832 71.073L50.4222 70.843L51.9072 71.651L50.2682 71.881Z",
    fill: "black"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1866 71.1899V72.9589V74.7299V76.4989L53.5456 76.7299L51.9066 76.9599L50.2676 77.1899V75.4209V73.6499V71.881L51.9066 71.6509L53.5456 71.4209L55.1866 71.1899Z",
    fill: "black"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2682 71.882L48.7832 71.074L50.4222 70.844L51.9072 71.652L50.2682 71.882Z",
    fill: "#B4B4B4"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2653 73.65L48.7803 72.842V71.073L50.2653 71.881V73.65Z",
    fill: "#828282"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9743 79.4189L45.4893 78.6109V76.8419L46.9743 77.6499V79.4189Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9176 68.1089L50.4326 67.3009L52.0716 67.0709L53.5566 67.8789L51.9176 68.1089Z",
    fill: "black"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 75.651L47.1357 74.843V73.072L48.6207 73.88V75.651Z",
    fill: "black"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 75.651L47.1357 74.843V73.072L48.6207 73.88V75.651Z",
    fill: "#828282"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2711 70.112L48.7861 69.304L50.4251 69.074L51.9101 69.882L50.2711 70.112Z",
    fill: "black"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2711 70.112L48.7861 69.304L50.4251 69.074L51.9101 69.882L50.2711 70.112Z",
    fill: "#B4B4B4"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9782 77.651L45.4932 76.843V75.074L46.9782 75.882V77.651Z",
    fill: "black"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6237 73.88L47.1387 73.072V71.303L48.6237 72.111V73.88Z",
    fill: "#828282"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6237 73.88L47.1387 73.072V71.303L48.6237 72.111V73.88Z",
    fill: "black"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M50.275 68.3419L48.79 67.534L50.429 67.304L51.914 68.112L50.275 68.3419Z",
    fill: "black"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9811 75.882L45.4961 75.074V73.303L46.9811 74.111V75.882Z",
    fill: "black"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6276 72.1119L47.1426 71.3039V69.5349L48.6276 70.3429V72.1119Z",
    fill: "black"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6305 70.342L47.1455 69.534L48.7865 69.303L50.2715 70.111L48.6305 70.342Z",
    fill: "black"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6276 72.1119L47.1426 71.3039V69.5349L48.6276 70.3429V72.1119Z",
    fill: "#828282"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6305 70.342L47.1455 69.534L48.7865 69.303L50.2715 70.111L48.6305 70.342Z",
    fill: "#B4B4B4"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M46.986 74.115L45.501 73.307V71.538L46.986 72.346V74.115Z",
    fill: "black"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6334 68.571L47.1484 67.763L48.7894 67.532L50.2744 68.34L48.6334 68.571Z",
    fill: "black"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9889 72.3409L45.5039 71.5329V69.7639L46.9889 70.5719V72.3409Z",
    fill: "black"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9957 68.8019L45.5107 67.9939L47.1497 67.7639L48.6347 68.5719L46.9957 68.8019Z",
    fill: "black"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9928 70.574L45.5078 69.766V67.995L46.9928 68.803V70.574Z",
    fill: "black"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4516 62.646L40.3516 113.963L87.8936 107.281L87.9936 55.965L40.4516 62.646ZM46.9756 79.42V77.652V75.883V74.111V72.343V70.574V68.802L48.6136 68.572L50.2546 68.341L51.8936 68.111L53.5326 67.881L55.1736 67.651L56.8116 67.421L58.4506 67.191V68.963V70.732V72.501V74.273V76.041V77.81V79.579L56.8126 79.809L55.1736 80.039L53.5326 80.269L51.8936 80.499L50.2546 80.729L48.6136 80.959L46.9756 81.189V79.42ZM58.4216 93.728V95.497V97.265V99.037V100.806V102.575V104.346L56.7836 104.576L55.1446 104.807L53.5036 105.037L51.8646 105.267L50.2256 105.497L48.5846 105.727L46.9456 105.957V104.185V102.416V100.648V98.876V97.108V95.34V93.571L48.5836 93.341L50.2256 93.11L51.8636 92.88L53.5026 92.65L55.1436 92.42L56.7826 92.189L58.4206 91.959V93.728M78.0856 96.272L76.4446 96.503V98.272L78.0856 98.041V99.81V101.582L76.4446 101.812L74.8056 102.042L73.1666 102.272L71.5256 102.503V100.731L69.8876 100.961L68.2486 101.192V102.963L66.6096 103.193V101.421L64.9686 101.651V103.423L63.3306 103.653V101.882V100.113L61.6916 100.343V102.112V103.884L60.0506 104.115V102.343V100.574V98.806V97.034V95.266L61.6916 95.035V93.266L60.0496 93.497V91.728V89.956L58.4106 90.186L56.7726 90.416V88.648L58.4106 88.418L60.0496 88.188L61.6906 87.957V86.189L60.0496 86.419L58.4116 86.649L56.7726 86.879L55.1346 87.109V88.878V90.647L53.4936 90.877V89.108L51.8546 89.338V91.106L50.2156 91.337L48.5746 91.567V89.798L46.9356 90.028V88.259V86.487L48.5746 86.257L50.2156 86.026V84.258L48.5746 84.488L46.9366 84.718V82.949L48.5756 82.719L50.2166 82.489L51.8556 82.259L53.4946 82.029L55.1356 81.799V83.568L56.7736 83.338V81.569L58.4126 81.339L60.0516 81.109L61.6926 80.878V79.106L60.0516 79.337V77.568V75.8L61.6926 75.569V73.8L60.0516 74.031V72.259L61.6926 72.028L63.3316 71.798V70.029L61.6936 70.259L60.0516 70.489V68.721L61.6926 68.49L63.3306 68.26V66.488L64.9696 66.258L66.6106 66.027L68.2496 65.797V67.568V69.337V71.106V72.877V74.646L66.6106 74.876V76.645L68.2486 76.415V78.184L66.6096 78.414V76.646L64.9676 76.876V78.645L63.3286 78.875V80.646L61.6896 80.876V82.645L60.0486 82.875L58.4096 83.105L56.7706 83.335V85.104L58.4096 84.874L60.0476 84.644L61.6886 84.413V86.185L63.3276 85.955V84.183L64.9666 83.953V82.184V80.416L66.6076 80.185V81.954L68.2466 81.724V79.955L69.8856 79.725V81.493L71.5246 81.263V79.494L73.1656 79.264V81.032V82.801V84.573V86.342V88.111V89.882L71.5246 90.112V88.341V86.572L69.8866 86.802L68.2476 87.032V88.8V90.572L69.8866 90.342V92.111L68.2486 92.341V90.572L66.6096 90.802V92.571L64.9686 92.802V94.57L66.6096 94.34V96.109L68.2476 95.879V94.11L69.8866 93.879V95.648L71.5256 95.418V97.19L73.1666 96.959V95.188V93.419L71.5256 93.649V91.88L73.1666 91.65V93.419L74.8056 93.188V91.42V89.651L76.4436 89.421L78.0856 89.19V90.959V92.728L79.7246 92.498V94.266L78.0856 94.497V96.268M81.3566 99.345L79.7176 99.575V97.806L81.3556 97.576V99.344M81.3756 88.729V90.497L79.7366 90.727V88.959V87.187L81.3756 86.957V88.729ZM81.3816 85.189L79.7426 85.419L78.1046 85.65V83.881V82.109L76.4636 82.34V84.111V85.88L74.8246 86.11V84.341V82.569V80.801V79.032L76.4636 78.802V80.571L78.1046 80.34V78.572L79.7436 78.342V80.111L78.1046 80.341V82.11L79.7436 81.88V83.651L81.3816 83.421V85.19M81.4176 65.726V67.495V69.263V71.035V72.804V74.573V76.341L79.7786 76.571L78.1406 76.801L76.4986 77.031L74.8606 77.261L73.2216 77.491L71.5806 77.722L69.9426 77.952V76.183V74.414V72.646V70.874V69.105V67.336V65.565L71.5816 65.335L73.2226 65.105L74.8616 64.875L76.4996 64.645L78.1416 64.415L79.7796 64.185L81.4186 63.955V65.727",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3607 97.585V99.354L79.7217 99.584V97.815L81.3607 97.585Z",
    fill: "black"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3802 86.9669V88.7379V90.5069L79.7412 90.7369V88.9689V87.1969L81.3802 86.9669Z",
    fill: "black"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8021 98.5059L73.1631 98.7369V96.9679L74.8021 96.7379V98.5059Z",
    fill: "#DFDFDF"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7503 81.8889V83.6599L81.3893 83.4299V85.1989L79.7503 85.4289L78.1113 85.6589V83.8899V82.1179L79.7503 81.8889Z",
    fill: "black"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1771 91.6589V93.4279L71.5361 93.6589V91.8899L73.1771 91.6589Z",
    fill: "black"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2451 99.428V97.659L69.8841 97.428V99.197L68.2451 99.428Z",
    fill: "#DFDFDF"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8841 99.198L68.2451 99.429V97.66L69.8841 97.429V99.198Z",
    fill: "black"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4779 78.812V80.581L78.1189 80.35V82.119L76.4779 82.35V84.121V85.89L74.8389 86.12V84.351V82.58V80.811V79.042L76.4779 78.812Z",
    fill: "black"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6953 96.8099L63.3343 96.58V98.351L61.6953 98.5809V96.8099Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9134 83.2679V85.039L68.2744 85.269V83.498L69.9134 83.2679Z",
    fill: "#DFDFDF"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6332 85.5039L64.9922 85.7349V83.9639L66.6332 83.7329V85.5039Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3431 91.273V93.042L61.7041 93.272V91.503V89.732L63.3431 89.502L64.9821 89.272V87.503L66.6231 87.272V89.041V90.812L64.9821 91.043L63.3431 91.273Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2884 76.424V78.1929L66.6494 78.4229V76.655L68.2884 76.424Z",
    fill: "black"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6527 74.886V76.655L65.0117 76.885V75.116L66.6527 74.886Z",
    fill: "black"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7833 64.193L81.4223 63.963V65.734V67.503V69.272V71.043V72.812V74.581V76.35L79.7833 76.58L78.1443 76.81L76.5033 77.041L74.8643 77.271L73.2253 77.501L71.5843 77.732L69.9453 77.962V76.193V74.424V72.655V70.884V69.115V67.346V65.575L71.5843 65.345L73.2253 65.114L74.8643 64.884L76.5033 64.654L78.1443 64.423L79.7833 64.193Z",
    fill: "black"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0081 76.885V78.654L63.3691 78.884V77.115L65.0081 76.885Z",
    fill: "black"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1677 81.807V83.576L56.8067 83.346V85.115L58.4457 84.885L60.0847 84.655L61.7257 84.424V86.196L60.0847 86.427L58.4457 86.657L56.8067 86.887L55.1677 87.117V85.346L53.5267 85.577V83.808L51.8877 84.038V85.807L53.5267 85.577V87.348L55.1677 87.117V88.886V90.655L53.5267 90.886V89.117L51.8877 89.347V91.115L50.2487 91.346L48.6077 91.577V89.808L46.9688 90.038V88.269V86.498L48.6077 86.268L50.2487 86.037V84.268L48.6077 84.499L46.9688 84.729V82.96L48.6077 82.73L50.2487 82.499L51.8877 82.269L53.5267 82.039L55.1677 81.807Z",
    fill: "black"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5597 79.503L73.2007 79.272V81.041V82.81V84.582V86.35V88.119V89.89L71.5597 90.121V88.35V86.581L69.9207 86.811L68.2817 87.041V88.81V90.581L66.6427 90.811V89.04V87.271L65.0017 87.502V89.271L63.3627 89.501L61.7237 89.731V91.502V93.271L60.0827 93.502V91.733V89.961L58.4437 90.191L56.8047 90.421V88.653L58.4437 88.423L60.0827 88.193L61.7237 87.962V86.193L63.3627 85.963V84.192L65.0017 83.962V85.733L66.6427 85.502V83.731L65.0017 83.962V82.193V80.424L66.6427 80.193V81.962L68.2817 81.732V79.963L69.9207 79.733V81.502L71.5597 81.272V79.503Z",
    fill: "black"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1377 95.9619V97.7309V99.5019V101.271L53.4967 101.502L51.8577 101.732L50.2188 101.963V100.194V98.4229V96.6539L51.8577 96.4229L53.4967 96.1929L55.1377 95.9619Z",
    fill: "black"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3695 77.1149V78.8839L61.7305 79.1139V77.3459V75.5769L63.3695 75.3469V73.5779V71.8069L65.0085 71.5769L66.6495 71.3459V73.1169V74.8859L65.0085 75.1169V76.8859L63.3695 77.1149Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6654 67.808V69.577L65.0244 69.808V68.039L66.6654 67.808Z",
    fill: "#DFDFDF"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6625 69.577L65.0215 69.808V68.039L66.6625 67.808V69.577Z",
    fill: "black"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7348 75.577V77.346V79.115L60.0938 79.346V77.577V75.809L61.7348 75.577Z",
    fill: "black"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7247 80.886V82.655L60.0837 82.886L58.4447 83.116L56.8057 83.346V81.577L58.4447 81.347L60.0837 81.117L61.7247 80.886Z",
    fill: "black"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3796 71.8059V73.5769V75.3459L61.7406 75.5759V73.8069L60.0996 74.0379V72.2659L61.7406 72.0349L63.3796 71.8059Z",
    fill: "black"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8838 84.0359L53.5228 83.8059V85.5749L51.8838 85.8049V84.0359Z",
    fill: "#DFDFDF"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6694 66.036L68.3084 65.806V67.577V69.346V71.115V72.886V74.655L66.6694 74.885V73.116V71.345L65.0284 71.576L63.3894 71.806V70.037L61.7504 70.267L60.1094 70.498V68.729L61.7504 68.498L63.3894 68.268V66.497L65.0284 66.267L66.6694 66.036Z",
    fill: "black"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M56.826 70.9589V72.7279V74.4989V76.2679V78.0369L55.187 78.2669L53.546 78.4979L51.907 78.7279L50.268 78.9579L48.627 79.1889V77.4199V75.6509V73.8799V72.1109V70.3429L50.268 70.1119L51.907 69.8819L53.546 69.6519L55.187 69.4209L56.826 69.1909V70.9589Z",
    fill: "black"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8943 78.7279L50.2552 78.9579L48.6143 79.1889V77.4199V75.6509V73.8799V72.1109V70.3429L50.2552 70.1119L51.8943 69.8819L53.5332 69.6519L55.1743 69.4209L56.8132 69.1909V70.9599V72.7289V74.4999V76.2689V78.0379L55.1743 78.2679L53.5332 78.4989L51.8943 78.7279Z",
    fill: "#DFDFDF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2617 75.4249V73.6539V71.8849L51.9007 71.6549L53.5397 71.4249L55.1807 71.1949V72.9639V74.7349V76.504L53.5397 76.7349L51.9007 76.965L50.2617 77.1949V75.4249Z",
    fill: "#DFDFDF"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8321 67.4199L58.4711 67.1899V68.9609V70.7299V72.4989V74.2699V76.0389V77.8079V79.5769L56.8321 79.8069L55.1931 80.0369L53.5521 80.2679L51.9131 80.4979L50.2741 80.7279L48.6331 80.9589L46.9941 81.1889V79.4199V77.6509V75.8819V74.1109V72.3419V70.5729V68.8019L48.6331 68.5719L50.2741 68.3409L51.9131 68.1109L53.5521 67.8809L55.1931 67.6499L56.8321 67.4199Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 130,
    width: 9,
    height: 8
  }, _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M118.92 137.369L116.791 136.211C118.225 135.944 119.522 135.188 120.461 134.073C121.401 132.958 121.925 131.551 121.945 130.093L124.074 131.252C124.054 132.71 123.529 134.116 122.59 135.231C121.65 136.346 120.353 137.102 118.92 137.369Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.92 137.366L116.791 136.208C117.32 136.127 117.834 135.97 118.317 135.741L120.446 136.899C119.963 137.128 119.449 137.285 118.92 137.366Z",
    fill: "#14022B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.446 136.899L118.317 135.741C118.619 135.599 118.908 135.432 119.181 135.241L121.31 136.399C121.037 136.59 120.748 136.757 120.446 136.899Z",
    fill: "#13022A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.309 136.402L119.18 135.244C119.401 135.091 119.613 134.924 119.814 134.744L121.943 135.903C121.742 136.083 121.53 136.25 121.309 136.403",
    fill: "#120228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.943 135.9L119.814 134.741C120 134.574 120.175 134.397 120.339 134.21L122.469 135.368C122.305 135.555 122.129 135.732 121.944 135.899",
    fill: "#120227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.469 135.369L120.339 134.211C120.502 134.026 120.655 133.833 120.796 133.631L122.926 134.789C122.784 134.991 122.632 135.184 122.469 135.369Z",
    fill: "#110226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.927 134.79L120.797 133.632C120.946 133.421 121.081 133.2 121.204 132.973L123.333 134.131C123.211 134.358 123.075 134.579 122.927 134.79Z",
    fill: "#100224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.332 134.132L121.203 132.974C121.347 132.707 121.472 132.431 121.576 132.147L123.705 133.305C123.601 133.589 123.477 133.866 123.333 134.132",
    fill: "#100223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.705 133.303L121.576 132.145C121.819 131.487 121.944 130.791 121.945 130.09L124.074 131.249C124.073 131.95 123.948 132.646 123.704 133.303",
    fill: "#0F0222"
  }))), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M79.088 143.363L76.959 142.205L116.791 136.205L118.92 137.363L79.088 143.363Z",
    fill: "#13022E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 141,
    width: 6,
    height: 3
  }, _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M76.255 142.884L74.126 141.725C74.9935 142.187 75.9875 142.356 76.959 142.206L79.088 143.364C78.1166 143.514 77.1227 143.346 76.255 142.884Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.255 142.884L74.126 141.725C74.177 141.753 74.226 141.78 74.281 141.806L76.41 142.964C76.358 142.938 76.31 142.912 76.255 142.884Z",
    fill: "#120228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4102 142.964L74.2812 141.806C74.5466 141.936 74.8248 142.039 75.1113 142.112L77.2402 143.27C76.9538 143.197 76.6756 143.094 76.4102 142.964Z",
    fill: "#13022A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2374 143.27L75.1084 142.112C75.7122 142.265 76.3402 142.297 76.9564 142.206L79.0854 143.364C78.4692 143.455 77.8412 143.423 77.2374 143.27Z",
    fill: "#14022B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 137,
    width: 6,
    height: 6
  }, _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2503 142.872L74.1213 141.714C73.4038 141.307 72.8109 140.713 72.4067 139.994C72.0024 139.275 71.8021 138.459 71.8273 137.635L73.9563 138.793C73.9311 139.617 74.1314 140.433 74.5356 141.152C74.9399 141.871 75.5328 142.465 76.2503 142.872Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2503 142.872L74.1213 141.714C73.4038 141.307 72.8109 140.713 72.4067 139.994C72.0024 139.275 71.8021 138.459 71.8273 137.635L73.9563 138.793C73.9311 139.617 74.1314 140.433 74.5356 141.152C74.9399 141.871 75.5328 142.465 76.2503 142.872Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 137,
    width: 6,
    height: 8
  }, _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2972 144.489L73.1682 143.331C72.2113 142.79 71.4204 141.998 70.8806 141.04C70.3408 140.083 70.0727 138.996 70.1052 137.897L72.2342 139.055C72.2017 140.154 72.4698 141.241 73.0096 142.198C73.5494 143.156 74.3403 143.948 75.2972 144.489Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2972 144.489L73.1682 143.331C72.2113 142.79 71.4204 141.998 70.8806 141.04C70.3408 140.083 70.0727 138.996 70.1052 137.897L72.2342 139.055C72.2015 140.154 72.4695 141.241 73.0093 142.199C73.5491 143.157 74.3402 143.949 75.2972 144.49",
    fill: "#0F0222"
  }))), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M124.075 131.248L121.946 130.09L121.655 40.931L123.784 42.089L124.075 131.248Z",
    fill: "#0F0221"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 36,
    width: 5,
    height: 7
  }, _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M119.354 36.84L121.483 37.998C122.203 38.4063 122.797 39.0032 123.202 39.7242C123.608 40.4453 123.809 41.2632 123.784 42.09L121.654 40.931C121.679 40.1043 121.479 39.2866 121.073 38.5657C120.668 37.8448 120.074 37.2482 119.354 36.84Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.784 42.09L121.654 40.931C121.679 40.1043 121.479 39.2866 121.073 38.5657C120.668 37.8448 120.074 37.2482 119.354 36.84L121.483 37.998C122.203 38.4063 122.797 39.0032 123.202 39.7242C123.608 40.4453 123.809 41.2632 123.784 42.09Z",
    fill: "#0F0222"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 36,
    width: 6,
    height: 3
  }, _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M116.472 36.369C117.461 36.2143 118.475 36.3841 119.36 36.853L121.489 38.011C120.604 37.5421 119.59 37.3723 118.601 37.527L116.472 36.369Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.601 37.524L116.472 36.366C117.105 36.2721 117.751 36.3044 118.372 36.461L120.501 37.619C119.88 37.4631 119.234 37.4302 118.601 37.524Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.495 37.6189L118.366 36.4609C118.656 36.5352 118.937 36.6391 119.205 36.7709L121.334 37.9289C121.066 37.7972 120.785 37.6933 120.495 37.6189Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.335 37.929L119.206 36.771C119.258 36.797 119.306 36.824 119.361 36.851L121.49 38.009C121.439 37.982 121.39 37.955 121.335 37.929Z",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 34,
    width: 7,
    height: 3
  }, _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M120.314 35.234L122.443 36.392C121.265 35.7667 119.916 35.5397 118.598 35.745L116.469 34.587C117.787 34.3817 119.136 34.6087 120.314 35.234Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.597 35.745L116.468 34.587C117.307 34.4633 118.162 34.5061 118.985 34.713L121.114 35.871C120.291 35.6641 119.436 35.6213 118.597 35.745Z",
    fill: "#14022B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.113 35.871L118.984 34.713C119.371 34.812 119.746 34.9508 120.104 35.127L122.233 36.285C121.875 36.109 121.5 35.9703 121.113 35.871Z",
    fill: "#13022A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.237 36.285L120.108 35.127C120.175 35.161 120.244 35.1966 120.315 35.234L122.444 36.392C122.378 36.3546 122.309 36.319 122.237 36.285Z",
    fill: "#120228"
  }))), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M110.392 38.76L108.263 37.602L116.471 36.368L118.6 37.526L110.392 38.76Z",
    fill: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 37,
    width: 5,
    height: 4
  }, _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M106.767 39.479C106.755 39.0392 106.899 38.6094 107.174 38.2657C107.448 37.922 107.836 37.6865 108.267 37.601L110.396 38.7599C109.965 38.8453 109.578 39.0806 109.303 39.4241C109.028 39.7677 108.884 40.1973 108.896 40.6369C108.896 40.6499 108.896 40.6619 108.896 40.6749L106.767 39.517V39.479Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.727 41.5869L106.598 40.4289C106.71 40.1248 106.768 39.8032 106.768 39.4789C106.767 39.2419 106.808 39.0066 106.89 38.7839L109.02 39.9419C108.938 40.1645 108.897 40.3998 108.898 40.6369C108.898 40.9612 108.839 41.2829 108.727 41.5869Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.02 39.9419L106.89 38.7839C106.922 38.6965 106.96 38.6116 107.005 38.5299L109.134 39.6879C109.09 39.7698 109.052 39.8546 109.02 39.9419Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.133 39.686L107.004 38.528C107.04 38.4589 107.08 38.3921 107.125 38.328L109.254 39.486C109.21 39.5502 109.169 39.617 109.133 39.686Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.254 39.492L107.123 38.333C107.164 38.275 107.208 38.2192 107.255 38.166L109.384 39.324C109.337 39.3771 109.293 39.4328 109.252 39.491",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.386 39.324L107.257 38.166C107.304 38.1129 107.354 38.0625 107.407 38.015L109.536 39.173C109.483 39.2205 109.434 39.2709 109.387 39.324",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.535 39.1729L107.406 38.0149C107.462 37.964 107.522 37.9169 107.584 37.8739L109.713 39.0319C109.651 39.0751 109.592 39.1222 109.535 39.1729Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.714 39.033L107.585 37.875C107.662 37.8216 107.744 37.7748 107.829 37.735L109.958 38.893C109.873 38.933 109.791 38.9798 109.714 39.033Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.958 38.892L107.829 37.7339C107.967 37.6689 108.113 37.6241 108.264 37.601L110.393 38.7599C110.242 38.7827 110.096 38.8272 109.958 38.892Z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 39,
    width: 5,
    height: 5
  }, _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M106.767 39.516L108.896 40.674C108.88 41.3384 108.635 41.9769 108.204 42.4826C107.773 42.9883 107.181 43.3305 106.527 43.452L104.398 42.294C105.052 42.1725 105.644 41.8303 106.075 41.3246C106.506 40.8189 106.751 40.1804 106.767 39.516Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.527 43.4489L104.398 42.2909C104.641 42.2535 104.877 42.181 105.098 42.0759L107.227 43.2339C107.006 43.3393 106.77 43.4118 106.527 43.4489Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.231 43.2379L105.102 42.0799C105.241 42.0151 105.375 41.9389 105.502 41.8519L107.632 43.0099C107.505 43.097 107.37 43.1733 107.231 43.2379Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.626 43.0099L105.496 41.8519C105.598 41.7814 105.695 41.7046 105.787 41.6219L107.916 42.78C107.824 42.8626 107.727 42.9395 107.625 43.0099",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.918 42.7789L105.789 41.6209C105.874 41.5443 105.954 41.4628 106.03 41.377L108.159 42.5349C108.083 42.6208 108.003 42.7023 107.918 42.7789Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.158 42.535L106.029 41.381C106.104 41.2964 106.174 41.2076 106.239 41.115L108.368 42.273C108.304 42.3656 108.234 42.4545 108.159 42.539",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.368 42.2689L106.239 41.1109C106.307 41.0146 106.369 40.9144 106.425 40.8109L108.554 41.9689C108.498 42.0726 108.436 42.1728 108.367 42.2689",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.555 41.966L106.426 40.808C106.492 40.6855 106.549 40.5585 106.597 40.428L108.726 41.586C108.678 41.7165 108.621 41.8435 108.555 41.966Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.727 41.5869L106.598 40.4289C106.71 40.1248 106.768 39.8032 106.768 39.4789C106.767 39.2419 106.808 39.0066 106.89 38.7839L109.02 39.9419C108.938 40.1645 108.897 40.3998 108.898 40.6369C108.898 40.9612 108.839 41.2829 108.727 41.5869Z",
    fill: "#858585"
  }))), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8399 45.6619L89.7109 44.504L104.399 42.2939L106.528 43.452L91.8399 45.6619Z",
    fill: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 44,
    width: 3,
    height: 2
  }, _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6982 44.506H89.7112L91.8402 45.664H91.8282L89.6982 44.506Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0001 45.62L88.8711 44.462C89.1453 44.5309 89.4304 44.5452 89.7101 44.504L91.8391 45.662C91.5594 45.7032 91.2743 45.6889 91.0001 45.62Z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 44,
    width: 4,
    height: 2
  }, _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4277 44.286C88.8171 44.493 89.2626 44.5694 89.6987 44.504L91.8277 45.662C91.3916 45.7275 90.9461 45.6511 90.5567 45.444L88.4277 44.286Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5568 45.446L88.4268 44.288L88.4978 44.325L90.6278 45.486L90.5578 45.449",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.628 45.4829L88.499 44.325C88.6183 44.3836 88.7433 44.4299 88.872 44.463L91.001 45.6209C90.8723 45.5878 90.7473 45.5416 90.628 45.4829Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0011 45.6199L88.8721 44.4619C89.1463 44.5308 89.4314 44.5451 89.7111 44.5039L91.8401 45.6619C91.5604 45.7031 91.2753 45.6888 91.0011 45.6199Z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 42,
    width: 4,
    height: 4
  }, _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5365 45.4349L88.4075 44.2759C88.078 44.0895 87.8057 43.8165 87.6199 43.4866C87.4342 43.1567 87.3421 42.7824 87.3535 42.4039L89.4825 43.5619C89.471 43.9405 89.5631 44.315 89.7488 44.6451C89.9346 44.9752 90.2069 45.2483 90.5365 45.4349Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5365 45.4349L88.4075 44.2759C88.078 44.0895 87.8057 43.8165 87.6199 43.4866C87.4342 43.1567 87.3421 42.7824 87.3535 42.4039L89.4825 43.5619C89.4712 43.9403 89.5633 44.3147 89.7491 44.6445C89.9348 44.9744 90.2071 45.2474 90.5365 45.4339",
    fill: "#0F0222"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 41,
    width: 4,
    height: 3
  }, _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6699 41.11L88.7989 42.268C89.021 42.4013 89.2021 42.593 89.3226 42.8223C89.443 43.0515 89.4982 43.3095 89.4819 43.568L87.3539 42.405C87.3691 42.1472 87.3134 41.8903 87.1928 41.662C87.0722 41.4337 86.8914 41.2427 86.6699 41.11Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.4819 43.563L87.3539 42.405C87.3692 42.1473 87.3136 41.8904 87.1932 41.6621C87.0728 41.4338 86.8922 41.2429 86.6709 41.11L88.7999 42.268C89.0219 42.4013 89.2031 42.593 89.3235 42.8223C89.444 43.0515 89.4991 43.3095 89.4829 43.568",
    fill: "#0F0222"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 40,
    width: 4,
    height: 3
  }, _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8486 40.978C86.1364 40.9326 86.4311 40.9817 86.6886 41.118L88.8176 42.276C88.5601 42.1399 88.2654 42.0908 87.9776 42.136L85.8486 40.978Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9776 42.1371L85.8486 40.9791C86.0326 40.9515 86.2202 40.9606 86.4006 41.0061L88.5306 42.1641C88.3502 42.1187 88.1616 42.1095 87.9776 42.1371Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5304 42.1641L86.4004 41.0061C86.4843 41.0276 86.5657 41.0578 86.6434 41.0961L88.7724 42.2541C88.6947 42.2159 88.6133 42.1857 88.5294 42.1641",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7726 42.2531L86.6436 41.0951L86.6886 41.1181L88.8176 42.2761L88.7726 42.2531Z",
    fill: "#9E9E9E"
  }))), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8106 43.5149L76.6816 42.3569L85.8446 40.976L87.9736 42.1339L78.8106 43.5149Z",
    fill: "#B4B4B4"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8106 41.737L76.6816 40.579L116.467 34.588L118.596 35.746L78.8106 41.737Z",
    fill: "#13022E"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9552 138.797L71.8262 137.639L71.5352 48.48L73.6642 49.638L73.9552 138.797Z",
    fill: "#828282"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2345 139.054L70.1055 137.896L69.8145 48.733L71.9435 49.891L72.2345 139.054Z",
    fill: "#0F0221"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 42,
    width: 8,
    height: 8
  }, _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6642 49.638L71.5342 48.48C71.5521 47.0218 72.0754 45.615 73.0147 44.4995C73.954 43.384 75.2513 42.6289 76.6852 42.363L78.8142 43.521C77.3805 43.7871 76.0835 44.5423 75.1443 45.6578C74.2052 46.7732 73.682 48.18 73.6642 49.638Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6642 49.633L71.5342 48.475C71.5343 47.7725 71.6592 47.0757 71.9032 46.417L74.0322 47.575C73.7881 48.2337 73.6642 48.9305 73.6642 49.633Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0333 47.5741L71.9043 46.4161C72.0081 46.1322 72.1321 45.8562 72.2753 45.5901L74.4043 46.7481C74.2613 47.014 74.1373 47.2907 74.0333 47.5741Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4054 46.75L72.2764 45.592C72.3987 45.3646 72.5343 45.1446 72.6824 44.933L74.8114 46.091C74.6632 46.3025 74.5276 46.5225 74.4054 46.75Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8106 46.0891L72.6816 44.9311C72.8232 44.7298 72.9757 44.5365 73.1386 44.3521L75.2676 45.5101C75.1047 45.6945 74.9522 45.8878 74.8106 46.0891Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2667 45.511L73.1377 44.353C73.3026 44.1666 73.4779 43.9897 73.6627 43.823L75.7917 44.981C75.6069 45.1477 75.4316 45.3246 75.2667 45.511Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7921 44.981L73.6631 43.823C73.8637 43.6431 74.0754 43.4761 74.2971 43.323L76.4261 44.481C76.2044 44.6341 75.9927 44.8011 75.7921 44.981Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4259 44.48L74.2969 43.322C74.5702 43.1318 74.8589 42.9645 75.1599 42.822L77.2889 43.98C76.988 44.1227 76.6993 44.2899 76.4259 44.48Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2892 43.982L75.1602 42.824C75.6436 42.5956 76.1576 42.4387 76.6862 42.358L78.8152 43.516C78.2866 43.5967 77.7726 43.7536 77.2892 43.982Z",
    fill: "#A8A8A8"
  }))), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M125.504 41.831L125.796 130.99C125.769 132.934 125.07 134.808 123.817 136.295C122.565 137.782 120.836 138.789 118.925 139.146L79.1443 145.137C78.2745 145.285 77.3826 145.237 76.5338 144.996C75.685 144.755 74.9008 144.328 74.2386 143.745C73.5763 143.162 73.0527 142.438 72.7061 141.627C72.3595 140.815 72.1987 139.937 72.2353 139.055L71.9443 49.892C71.9714 47.9489 72.6702 46.075 73.9219 44.5885C75.1736 43.102 76.9012 42.0945 78.8113 41.737L118.596 35.746C119.466 35.598 120.358 35.6463 121.207 35.8874C122.056 36.1286 122.84 36.5565 123.503 37.1398C124.165 37.7231 124.688 38.4471 125.035 39.2588C125.381 40.0705 125.541 40.9493 125.504 41.831ZM118.919 137.367C120.353 137.1 121.65 136.344 122.589 135.229C123.529 134.113 124.053 132.707 124.073 131.249L123.782 42.09C123.813 41.4322 123.696 40.7759 123.44 40.169C123.185 39.5621 122.797 39.0199 122.305 38.5818C121.813 38.1438 121.23 37.821 120.598 37.637C119.966 37.4529 119.3 37.4123 118.65 37.518L110.391 38.76C109.974 38.8375 109.596 39.0574 109.323 39.3821C109.049 39.7069 108.897 40.1165 108.891 40.541C108.901 41.2273 108.669 41.895 108.236 42.4274C107.803 42.9598 107.196 43.3228 106.522 43.453L91.8643 45.658C91.5643 45.7101 91.2563 45.6943 90.9632 45.6118C90.67 45.5293 90.3991 45.3822 90.1702 45.1813C89.9413 44.9803 89.7604 44.7307 89.6407 44.4506C89.521 44.1706 89.4655 43.8673 89.4783 43.563C89.4988 43.3649 89.4738 43.1648 89.4052 42.9778C89.3367 42.7908 89.2264 42.6219 89.0827 42.484C88.939 42.3461 88.7657 42.2429 88.5761 42.182C88.3864 42.1212 88.1854 42.1044 87.9883 42.133L78.8193 43.513C77.3856 43.7791 76.0886 44.5343 75.1495 45.6497C74.2103 46.7652 73.6872 48.172 73.6693 49.63L73.9603 138.79C73.9302 139.448 74.0472 140.104 74.3029 140.711C74.5586 141.318 74.9464 141.86 75.4382 142.298C75.93 142.736 76.5133 143.059 77.1457 143.243C77.778 143.426 78.4434 143.467 79.0933 143.361L118.925 137.361",
    fill: "#1A0339"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6 37.524C119.253 37.4119 119.923 37.4473 120.56 37.6278C121.197 37.8083 121.786 38.1292 122.283 38.5671C122.78 39.0049 123.173 39.5485 123.433 40.1579C123.692 40.7674 123.812 41.4272 123.783 42.089L124.074 131.248C124.054 132.706 123.53 134.112 122.59 135.228C121.65 136.343 120.354 137.099 118.92 137.366L79.1381 143.356C78.4853 143.468 77.8157 143.433 77.1784 143.252C76.5411 143.072 75.9524 142.751 75.4553 142.313C74.9582 141.876 74.5654 141.332 74.3058 140.723C74.0462 140.113 73.9264 139.454 73.9551 138.792L73.6641 49.632C73.6819 48.174 74.2051 46.7672 75.1442 45.6517C76.0833 44.5363 77.3804 43.7811 78.8141 43.515L87.9771 42.134C88.1663 42.1019 88.3605 42.1125 88.5451 42.1652C88.7298 42.2179 88.9003 42.3112 89.0441 42.4384C89.188 42.5655 89.3015 42.7233 89.3764 42.9001C89.4514 43.0769 89.4857 43.2682 89.4771 43.46C89.452 43.7691 89.4972 44.0798 89.6092 44.369C89.7212 44.6581 89.8971 44.9182 90.1238 45.1298C90.3505 45.3413 90.622 45.4989 90.9182 45.5908C91.2144 45.6826 91.5275 45.7063 91.8341 45.66L106.522 43.45C107.182 43.3272 107.778 42.9794 108.21 42.4659C108.642 41.9524 108.883 41.305 108.891 40.634C108.879 40.1944 109.023 39.7648 109.298 39.4212C109.572 39.0777 109.96 38.8424 110.391 38.757L118.6 37.524Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 40,
    width: 10,
    height: 10
  }, _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9435 49.892L69.8145 48.734C69.8417 46.7909 70.5405 44.9171 71.7922 43.4307C73.0439 41.9442 74.7714 40.9366 76.6814 40.579L78.8105 41.737C76.9003 42.0945 75.1727 43.102 73.921 44.5885C72.6693 46.075 71.9706 47.9489 71.9435 49.892Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9435 49.892L69.8145 48.734C69.8148 47.8002 69.981 46.8738 70.3055 45.998L72.4344 47.1561C72.1098 48.0317 71.9435 48.9581 71.9435 49.892Z",
    fill: "#0F0222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4347 47.1559L70.3057 45.998C70.446 45.6199 70.6131 45.2523 70.8057 44.8979L72.9347 46.056C72.7421 46.4103 72.575 46.7779 72.4347 47.1559Z",
    fill: "#100223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9308 46.054L70.8018 44.896C70.9652 44.5919 71.1465 44.2977 71.3448 44.015L73.4738 45.173C73.2755 45.4557 73.0942 45.7499 72.9308 46.054Z",
    fill: "#100224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4737 45.173L71.3447 44.015C71.5337 43.7454 71.7377 43.4867 71.9557 43.24L74.0847 44.398C73.8668 44.6448 73.6628 44.9035 73.4737 45.173Z",
    fill: "#110226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0841 44.398L71.9551 43.24C72.1747 42.9906 72.4085 42.7538 72.6551 42.531L74.7851 43.689C74.5384 43.9117 74.3047 44.1485 74.0851 44.398",
    fill: "#120227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7872 43.69L72.6572 42.532C72.9247 42.2913 73.2073 42.0678 73.5032 41.863L75.6322 43.021C75.3362 43.2257 75.0536 43.4492 74.7862 43.69",
    fill: "#120228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6329 43.02L73.5039 41.862C73.8685 41.6091 74.2535 41.387 74.6549 41.198L76.7839 42.356C76.3825 42.545 75.9975 42.7671 75.6329 43.02Z",
    fill: "#13022A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7833 42.356L74.6543 41.198C75.2964 40.8943 75.9792 40.6854 76.6813 40.578L78.8103 41.736C78.1079 41.8434 77.4257 42.0522 76.7833 42.356Z",
    fill: "#14022B"
  }))), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M114.286 116.578C114.295 117.498 113.972 118.391 113.375 119.092C112.779 119.793 111.95 120.256 111.04 120.396L89.8115 123.653C89.2691 123.736 88.7152 123.702 88.1873 123.552C87.6594 123.403 87.1698 123.142 86.7517 122.786C86.3336 122.431 85.9969 121.99 85.7642 121.493C85.5316 120.996 85.4086 120.455 85.4035 119.906C85.395 118.985 85.7187 118.093 86.315 117.391C86.9114 116.69 87.7406 116.227 88.6505 116.088L109.879 112.831C110.422 112.748 110.976 112.782 111.503 112.932C112.031 113.081 112.521 113.343 112.939 113.698C113.357 114.054 113.693 114.495 113.926 114.991C114.158 115.488 114.281 116.029 114.286 116.578Z",
    fill: "#565ADD"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7078 118.354C95.7034 118.297 95.68 118.251 95.6376 118.219C95.5952 118.186 95.5371 118.169 95.4632 118.167C95.4131 118.166 95.3705 118.173 95.3357 118.186C95.3008 118.199 95.2739 118.218 95.2549 118.242C95.2364 118.266 95.2268 118.294 95.2261 118.325C95.2246 118.351 95.2295 118.374 95.2409 118.393C95.2528 118.413 95.2693 118.43 95.2903 118.445C95.3113 118.459 95.3356 118.472 95.3633 118.483C95.391 118.493 95.4207 118.503 95.4522 118.51L95.5822 118.544C95.6453 118.56 95.7031 118.58 95.7556 118.605C95.8082 118.63 95.8534 118.66 95.8915 118.695C95.9296 118.731 95.9587 118.772 95.979 118.819C95.9998 118.867 96.0097 118.921 96.0089 118.981C96.0065 119.07 95.9821 119.147 95.9357 119.211C95.8898 119.275 95.8243 119.324 95.7393 119.358C95.6547 119.392 95.5533 119.408 95.4349 119.405C95.3175 119.403 95.2157 119.382 95.1294 119.344C95.0435 119.307 94.977 119.252 94.9298 119.18C94.883 119.108 94.8596 119.02 94.8595 118.915L95.157 118.922C95.1593 118.97 95.1723 119.011 95.1963 119.045C95.2206 119.077 95.2535 119.103 95.2948 119.12C95.3366 119.137 95.384 119.146 95.437 119.147C95.4891 119.148 95.5344 119.142 95.5731 119.127C95.6122 119.113 95.6428 119.093 95.6646 119.066C95.6865 119.04 95.6979 119.009 95.6986 118.974C95.6993 118.941 95.6902 118.914 95.6713 118.891C95.6528 118.868 95.6253 118.849 95.5887 118.832C95.5526 118.816 95.5082 118.801 95.4555 118.787L95.298 118.744C95.176 118.711 95.0802 118.662 95.0106 118.597C94.941 118.532 94.9076 118.446 94.9104 118.339C94.9118 118.251 94.9369 118.174 94.9857 118.109C95.0349 118.045 95.1016 117.995 95.1857 117.96C95.2698 117.925 95.3649 117.908 95.4709 117.91C95.5789 117.913 95.6727 117.933 95.7523 117.972C95.8325 118.011 95.8943 118.063 95.9379 118.13C95.9814 118.197 96.003 118.274 96.0025 118.36L95.7078 118.354ZM97.5103 118.484L97.1993 118.477C97.1945 118.437 97.1837 118.401 97.1668 118.369C97.15 118.337 97.1281 118.31 97.1011 118.287C97.0741 118.264 97.0428 118.246 97.0071 118.234C96.9718 118.221 96.9334 118.214 96.8917 118.213C96.8165 118.212 96.7505 118.229 96.6938 118.265C96.6372 118.301 96.5927 118.354 96.5604 118.424C96.5281 118.494 96.5108 118.579 96.5086 118.68C96.5064 118.784 96.5199 118.871 96.5491 118.943C96.5788 119.014 96.6212 119.068 96.6763 119.105C96.7314 119.142 96.7956 119.162 96.869 119.163C96.9101 119.164 96.9484 119.16 96.9836 119.15C97.0194 119.139 97.0512 119.124 97.0791 119.104C97.107 119.083 97.1303 119.058 97.149 119.028C97.1681 118.998 97.1816 118.964 97.1896 118.925L97.5005 118.933C97.491 119 97.4695 119.064 97.436 119.125C97.4029 119.186 97.3589 119.24 97.3039 119.288C97.2493 119.335 97.1846 119.372 97.1096 119.399C97.0352 119.425 96.9513 119.437 96.8581 119.435C96.7284 119.432 96.613 119.401 96.5121 119.34C96.4116 119.279 96.3329 119.192 96.2762 119.079C96.2199 118.967 96.1935 118.832 96.1969 118.674C96.2004 118.515 96.2331 118.381 96.2952 118.271C96.3572 118.161 96.44 118.078 96.5435 118.022C96.6471 117.965 96.7627 117.939 96.8905 117.941C96.9748 117.943 97.0526 117.957 97.1241 117.982C97.196 118.007 97.2594 118.043 97.3143 118.09C97.3691 118.136 97.4134 118.192 97.447 118.258C97.4811 118.324 97.5022 118.4 97.5103 118.484ZM97.9336 119.439L97.6041 119.432L98.1377 117.988L98.5339 117.997L99.0036 119.462L98.6741 119.455L98.3342 118.325L98.3229 118.325L97.9336 119.439ZM97.9254 118.867L98.7036 118.884L98.6984 119.124L97.9202 119.107L97.9254 118.867ZM100.427 118.038L100.395 119.492L100.129 119.486L99.5166 118.557L99.506 118.557L99.4861 119.472L99.1786 119.466L99.2102 118.012L99.48 118.017L100.088 118.946L100.101 118.946L100.121 118.031L100.427 118.038Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9482 73.7089L87.3962 72.5499L110.553 68.3889L116.962 67.2369V103.251L80.9492 109.722V73.7089H80.9482Z",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6113 86.275L85.9773 86.03L87.3433 85.784L88.7093 85.539L90.0753 85.293L91.4413 85.048L92.8073 84.803L94.1733 84.557V75L92.8073 75.245L91.4413 75.49L90.0753 75.736L88.7093 75.981L87.3433 76.226L85.9773 76.471L84.6113 76.717V86.279M85.9773 84.668L87.3433 84.423L88.7093 84.177L90.0753 83.932L91.4413 83.687L92.8073 83.442V76.612L91.4413 76.858L90.0753 77.1L88.7093 77.345L87.3433 77.59L85.9773 77.836V84.666",
    fill: "black"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.003 80.597L102.369 80.351V73.521L101.003 73.766L99.6371 74.011L98.2711 74.256V75.622L96.9051 75.868L95.5391 76.113V77.479L96.9051 77.233L98.2711 76.988V78.354L99.6371 78.108L101.003 77.863V80.595M99.6371 76.742L101.003 76.497V75.131L99.6371 75.376V76.742Z",
    fill: "black"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.736 82.838L105.102 82.593L106.468 82.348L107.834 82.103L109.2 81.8569L110.566 81.612L111.932 81.366L113.298 81.121V71.559L111.932 71.805L110.566 72.05L109.2 72.295L107.834 72.541L106.468 72.7859L105.102 73.032L103.736 73.277V82.839M105.102 81.228L106.468 80.983L107.834 80.738L109.2 80.493L110.566 80.2469L111.932 80.002V73.172L110.566 73.417L109.2 73.662L107.834 73.907L106.468 74.153L105.102 74.3979V81.228Z",
    fill: "black"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3438 83.052L88.7098 82.807L90.0758 82.561L91.4418 82.315V78.215L90.0758 78.46L88.7098 78.706L87.3438 78.951V83.051",
    fill: "black"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.468 79.6149L107.834 79.3699L109.2 79.1239L110.566 78.8779V74.778L109.2 75.0239L107.834 75.269L106.468 75.515V79.6149Z",
    fill: "black"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9051 81.331L98.2711 81.086V78.354L96.9051 78.599L95.5391 78.844V80.21L96.9051 79.965V81.331Z",
    fill: "black"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.543 84.3109L96.909 84.0659V81.33L95.543 81.5759V84.308",
    fill: "black"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6387 82.2089L101.005 81.9629V80.5969L99.6387 80.8429",
    fill: "black"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2715 83.821L99.6375 83.576V82.21L98.2715 82.455",
    fill: "black"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.003 83.3289L102.369 83.0829V81.7169L101.003 81.9629",
    fill: "black"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9053 85.4319L98.2713 85.1859V83.8199L96.9053 84.0659",
    fill: "black"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9773 94.222L87.3433 93.977L88.7093 93.731V92.365L90.0753 92.119V93.485L91.4413 93.24V90.512L90.0753 90.758V89.392L88.7093 89.637V88.271L90.0753 88.026V89.392L91.4413 89.146V90.512L92.8073 90.266L94.1733 90.021L95.5393 89.776L96.9053 89.531V88.165L95.5393 88.411L94.1733 88.657L92.8073 88.902V87.536L91.4413 87.782V86.416L90.0753 86.662L88.7093 86.907L87.3433 87.153L85.9773 87.399L84.6113 87.645V89.011L85.9773 88.765L87.3433 88.52V89.886L85.9773 90.131L84.6113 90.377V93.109L85.9773 92.864V94.222Z",
    fill: "black"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8076 87.5339L94.1736 87.2879L95.5396 87.0429L96.9056 86.7969V85.4309L95.5396 85.6769L94.1736 85.9219L92.8076 86.1669V87.5339Z",
    fill: "black"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5396 95.24L96.9056 94.995V92.263L98.2716 92.018L99.6376 91.772V90.406L101.004 90.161V92.893L102.37 92.647V89.913L103.736 89.668L105.102 89.422V92.154L106.468 91.909V83.709L105.102 83.954V85.32L103.736 85.566V84.2L102.37 84.445V85.813L101.004 86.058V84.692L99.6376 84.937V87.669L101.004 87.423V88.789L99.6376 89.035V87.669L98.2716 87.914V89.28L96.9056 89.525V90.891L95.5396 91.137L94.1736 91.382L92.8076 91.628V92.994L94.1736 92.749L95.5396 92.504V95.236M102.37 88.544L103.736 88.299V86.933L102.37 87.178V88.544Z",
    fill: "black"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.833 88.9319L109.199 88.6869V85.9549L110.565 85.7099V84.3439L109.199 84.5889V83.2229L107.833 83.4679V88.9319Z",
    fill: "black"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.566 84.3439L111.932 84.0979V82.7319L110.566 82.9779",
    fill: "black"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.566 88.442L111.932 88.197L113.298 87.951V86.585L111.932 86.831V85.465L110.566 85.71V88.442Z",
    fill: "black"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.933 92.2939L113.299 92.0479V89.3159L111.933 89.5609V92.2929",
    fill: "black"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6113 105.399L85.9773 105.153L87.3433 104.908L88.7093 104.663L90.0753 104.417L91.4413 104.172L92.8073 103.926L94.1733 103.681V94.119L92.8073 94.364L91.4413 94.609L90.0753 94.855L88.7093 95.1L87.3433 95.345L85.9773 95.59L84.6113 95.836V105.398M85.9773 103.787L87.3433 103.541L88.7093 103.296L90.0753 103.05L91.4413 102.805L92.8073 102.56V95.733L91.4413 95.978L90.0753 96.224L88.7093 96.469L87.3433 96.714L85.9773 96.96V103.79",
    fill: "black"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.543 103.436L96.909 103.191V100.459L98.275 100.213V98.847L96.909 99.093V97.727L98.275 97.482V98.848L99.641 98.603L101.007 98.358V99.724L99.641 99.97L98.275 100.215V102.947L99.641 102.701V101.335L101.007 101.09V102.456L102.373 102.211V100.845L103.739 100.599L105.105 100.354V101.72L106.471 101.475L107.837 101.23L109.203 100.985L110.569 100.739V98.007L109.203 98.252V96.887L110.569 96.642V95.276L111.935 95.031V93.665L110.569 93.91V91.178L109.203 91.423L107.837 91.669V94.401L106.471 94.647V97.379L107.837 97.134V98.5L106.471 98.746V97.38L105.105 97.625V96.259L103.739 96.504V95.138L102.373 95.384V96.75L101.007 96.995V95.629L99.641 95.875V94.509L101.007 94.263V92.897L99.641 93.142L98.275 93.388V94.754L96.909 95V96.366L95.543 96.612V103.442M102.373 99.483L103.739 99.238V97.872L102.373 98.117V99.483Z",
    fill: "black"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.369 94.0119L103.735 93.7659V92.3999L102.369 92.6449",
    fill: "black"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.103 94.8869L106.469 94.6409V93.2789L105.103 93.5249",
    fill: "black"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3438 102.177L88.7098 101.931L90.0758 101.685L91.4418 101.44V97.34L90.0758 97.585L88.7098 97.831L87.3438 98.076V102.176",
    fill: "black"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.933 99.124L113.299 98.879V97.517L111.933 97.762",
    fill: "black"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M123.967 86.267L73.8165 94.6329L73.8105 91.7639L123.962 83.3979L123.967 86.267Z",
    fill: "#F4A82C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_492_23208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 80,
    width: 70,
    height: 112
  }, _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M159.645 80.599H90.2305V191.002H159.645V80.599Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_492_23208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.74 112.34L132.354 88.757C132.168 88.2091 131.817 87.7321 131.349 87.3919C130.881 87.0516 130.319 86.8648 129.74 86.8571H125.905V97.1091L128.171 101.389C128.49 101.989 129.955 111.169 129.507 111.674C127.788 113.616 127.422 115.347 122.453 126.825C121.913 128.072 120.453 132.209 119.308 132.867C118.437 133.365 117.409 133.514 116.432 133.285C115.455 133.056 114.6 132.466 114.04 131.633L104.891 118.465C104.482 117.828 103.934 117.291 103.288 116.895C102.643 116.498 101.917 116.252 101.163 116.174C100.41 116.097 99.6482 116.19 98.9356 116.446C98.2229 116.703 97.5771 117.117 97.0462 117.657C96.1682 118.599 95.6425 119.816 95.558 121.101C95.4734 122.386 95.8352 123.661 96.5822 124.71L105.65 137.764C107.02 139.735 107.781 142.065 107.841 144.464C107.996 150.708 109.241 163.993 116.541 173.653V201.543L138.185 193.069L141.231 115.683C141.286 114.547 141.12 113.412 140.74 112.34Z",
    fill: "#FFC89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.856 192.415V181.734C113.856 181.232 113.974 180.737 114.2 180.288C114.425 179.84 114.753 179.45 115.156 179.151C121.891 174.271 129.597 170.898 137.75 169.261C138.22 169.169 138.704 169.184 139.167 169.303C139.63 169.422 140.061 169.642 140.427 169.949C140.794 170.256 141.088 170.64 141.288 171.075C141.487 171.509 141.587 171.983 141.58 172.461L141.358 192.419L113.856 192.415Z",
    fill: "#565ADD"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_492_23208",
    x: -6.00977,
    y: -6,
    width: 216,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_492_23208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_492_23208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_492_23208",
    x: 3,
    y: 3,
    width: 194,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_492_23208"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_23208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(-0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodebusiness);
export default __webpack_public_path__ + "static/media/codebusiness.25438b9b2cee9cecef3f348943887ac6.svg";
export { ForwardRef as ReactComponent };